import React, { useState, useEffect, useCallback, useRef } from "react";
import useDarkMode from '../../hooks/useDarkMode';
import useThemeColor from "../../hooks/useThemeColor";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../app/auth/authSlice";
import { useNavigate, useParams, Link, useSearchParams } from "react-router-dom";
import "./updateItem.css";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import Preloader from "../../components/CustomComponents/preLoad/preLoader";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast";
import FormInput from "../../components/CustomComponents/Input/formInput";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery";
import ImageUploadWithGallery from "../../components/CustomComponents/ImageUploadWithGallery/ImageUploadWithGallery";
import {
  toRelativeMediaPath,
  uploadCompanyMediaFile,
} from "../../utils/mediaImageUtils";
import CategorySelector from "../../components/CustomComponents/modal/CategorySelector";
import ModifierGroupsSelector from "../../components/CustomComponents/modal/ModifierGroupsSelector";
import AllergenSelector from "../../components/CustomComponents/modal/AllergenSelector";
import MenuGroupsSelector from "../../components/CustomComponents/modal/MenuGroupsSelector";
import ProductMultiSelectionModal from "../../components/CustomComponents/modal/productMultiSelectionModel";

import DebugMUIDatePicker from "../../components/CustomComponents/MUIDatePicker/DebugMUIDatePicker";
import "../../components/CustomComponents/MUIDatePicker/MUIDatePicker.css";

import "react-datetime/css/react-datetime.css";
import "../../components/DateTimePicker/dateTimePicker.css";
import "../../components/DateTimePicker/materialUIOverrides.css";
import moment from "moment";
import swal from "sweetalert";

import ReportingCategoryModel from "../../components/CustomComponents/modal/reportingCategory";
import { Modifier } from "../modifiers/initializeModifier";
import "./UpdateItemShimmer.css";
import ItemTabBar from "./itemTabBar";
import BranchAssignmentSelector from "../../components/CustomComponents/BranchAssignment/BranchAssignmentSelector";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import { useAssignedBy } from "../../hooks/useStaffData";
import useIsChildBranch from "../../hooks/useIsChildBranch";

/** Stable JSON stringify (sorts object keys) so comparison is not affected by key order. */
function stableStringify(value) {
  if (value === null || value === undefined) return JSON.stringify(value);
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "string") return JSON.stringify(value);
  if (value instanceof Date) return JSON.stringify(value.getTime());
  if (Array.isArray(value)) return "[" + value.map((item) => stableStringify(item)).join(",") + "]";
  const keys = Object.keys(value).sort();
  const pairs = keys.map((k) => JSON.stringify(k) + ":" + stableStringify(value[k]));
  return "{" + pairs.join(",") + "}";
}

const UpdateItem = () => {
  const { ProductType, IsCombo, itemId } = useParams();
  const [searchParams] = useSearchParams();
  const includeArchived = searchParams.get("includeArchived") === "1";
  const [isComboItem, setIsComboItem] = useState(IsCombo === "Combo");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const CompID = useSelector((state) => state.auth.user)?.userData?.compID;
  const assignedBy = useAssignedBy();
  const { profileData, settingsData } = useSelector((state) => state.auth);
  const parentCompID = profileData?.parentComID ?? profileData?.ParentComID ?? 0;
  const hasProfileData = !!profileData;
  const hasSettingsData = !!settingsData;
  const profileCompCurrency = profileData?.compCurrency;
  const settingsVat = settingsData?.s_VAT;
  const settingsTaxEnabled = settingsData?.isTaxEnabled;
  const isBranchMode = useIsChildBranch();
  const [isParentCompanyProduct, setIsParentCompanyProduct] = useState(false);
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;
  const [compCurrency, setCompCurrency] = useState("GBP");

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  const [formState, setFormState] = useState({
    menuItem_Name: "",
    menuItem_KitchenDisplayName: "",
    menuItem_Detail: "",
    menuItem_RootType: ProductType || "",
    menuItem_ColorCode: "",
    menuItem_SalePrice: "",
    menuItem_CostPrice: "",
    menuItem_TaxPercentage: "",
    menuItem_TakeAwayPrice: "",
    menuItem_DeliveryPrice: "",
    menuItem_ServingSize: "",
    menuItem_PreparationTime: "",
    menuItem_SKU: "",
    menuItem_SEOTitle: "",
    menuItem_SEODescription: "",
    menuItem_Permalink: "",
    menuItem_ASTime: "",
    menuItem_AETime: "",
    menuItem_Rating: "",
    menuItem_BarCode: "",
    menuItem_Type: isComboItem ? "Combo" : "Product",
    menuItem_ImageAltText: "",
    retail_Markup: "",
    delivery_Markup: "",
    online_Markup: "",
    current_Quantity: "",
    reorder_Quantity: "",
    reorder_Level: "",
    availableQuantity: "",
    orderQuantityLimit: "",
    menuItem_DefaultModifierTitle: "",
    brand_ID: "",
    ingredientID: "",
    parentMenuItemID: "",
    itsMasterProductID: "",
    reportCat_ID: "",
    stadardUnit: "",
    unitSize: "",
    mP_UnitOfSale: "",
    mP_VolumnOfSale: "",
    menuItem_Orderby: "",
    localizeID: "en",
    appMode: "testing",
    menuItem_MeasurementType: "",
    menuItem_DefaultSize: "",
    menuItem_DefaultSizeUnit: "",
    menuItem_ContainerType: "",
    menuitem_DefaultSizeInBaseUnit: 0,
    menuItem_RecipeType: "Made to order",
  });

  const [errors, setErrors] = useState({
    menuItem_Name: "",
    menuItem_SalePrice: "",
  });

  const [toggles, setToggles] = useState({
    menuItem_Publish: true,
    is_ShowInKiosk: true,
    isSellOnTill: true,
    isActiveMobileApp: true,
    is_OutOfStock: false,
    skuEnabled: false,
    expiryDateEnabled: true,
    seoEnabled: true,
    modifierGroupsEnabled: false,
    allergensEnabled: false,
    menuGroupsEnabled: false,
    productsEnabled: isComboItem,
    menuItem_Homefeatured: false,
    menuItem_featured: false,
    menuItem_IsModifier: false,
    menuItem_IsFavorite: false,
    menuItem_HasVariant: false,
    isArchieve: false,
    isAllowedtoSetPriceatThePointofSale: false,
    isTaxExempt: false,
    isPreventGainingLoyalty: false,
    isHaveCustomerSpecificPricing: false,
    isProductisScannableOnly: false,
    isMasterProduct: false,
    itHasAMasterProduct: false,
    menuItem_IsDefaultModifier: false,
    isShowNotificationExpDate: false,
    isShowSocialMediaLink: false,
    menuItem_SellingMethodBoth: false,
    menuItem_IsSellingProduct: false,
  });

  const [imageState, setImageState] = useState({
    menuItem_Image: "",
    imageFile: null,
  });

  const [selectors, setSelectors] = useState({
    selectedParentCategory: [],
    selectedModifierGroups: [],
    selectedAllergens: [],
    selectedMenuGroups: [],
    selectedProducts: [],
  });

  const [reportingCategory, setReportingCategory] = useState({});
  const [products, setProducts] = useState([]);
  const [allAllergens, setAllAllergens] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [settings, setSettings] = useState({ s_VAT: "", isTaxEnabled: false });
  const [units, setUnits] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [hasUserEditedTax, setHasUserEditedTax] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchAssignments, setBranchAssignments] = useState([]);
  const [branchVariantOverrideRows, setBranchVariantOverrideRows] = useState([]);
  const [loadingBranchVariantOverrides, setLoadingBranchVariantOverrides] = useState(false);
  const [branchOverrideModalOpen, setBranchOverrideModalOpen] = useState(false);
  const [editingBranchAssignment, setEditingBranchAssignment] = useState(null);
  const [branchOverrideForm, setBranchOverrideForm] = useState({
    branchPublishMode: "inherit", // inherit | publish | unpublish
    branchOrderby: "",
    isPriceOverrideActive: false,
    branchPriceOverride: "",
    branchDeliveryPriceOverride: "",
    branchTakeAwayPriceOverride: "",
  });
  const [isVariantBranchOverrideMode, setIsVariantBranchOverrideMode] = useState(false);
  const [variantBranchOverrideItems, setVariantBranchOverrideItems] = useState([]);
  const [variantBranchOverrideForms, setVariantBranchOverrideForms] = useState({});
  const [isParentBranch, setIsParentBranch] = useState(false);
  const [modals, setModals] = useState({
    showParentCategoryModal: false,
    showReportingCategoryModal: false,
    showModifierModal: false,
    showAllergenModal: false,
    showMenuGroupModal: false,
    isModalOpen: false,
    showProductModal: false,
    showBranchAssignmentModal: false,
  });
  const [expiryDate, setExpiryDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [branchManagementSaving, setBranchManagementSaving] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [variants, setVariants] = useState([{ ...Modifier, menuItem_SellingMethodBoth: false, reportCat_ID: "" }]);
  const [savingVariantTrackStock, setSavingVariantTrackStock] = useState({});
  const isDarkMode = useDarkMode();
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  const hasFetchedDetailsRef = useRef(false);
  const prevMeasurementTypeRef = useRef(null);
  const baselineReadyRef = useRef(false);

  // Track initial state for change detection
  const [initialFormState, setInitialFormState] = useState(null);
  const [initialToggles, setInitialToggles] = useState(null);
  const [initialSelectors, setInitialSelectors] = useState(null);
  const [initialReportingCategory, setInitialReportingCategory] = useState(null);
  const [initialVariants, setInitialVariants] = useState([]);
  const [initialImageState, setInitialImageState] = useState(null);
  const [initialExpiryDate, setInitialExpiryDate] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [baselineReady, setBaselineReady] = useState(false);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);

  const captureBaselineSnapshot = useCallback(() => {
    setInitialFormState(JSON.parse(JSON.stringify(formState)));
    setInitialToggles(JSON.parse(JSON.stringify(toggles)));
    setInitialSelectors(JSON.parse(JSON.stringify(selectors)));
    setInitialReportingCategory(JSON.parse(JSON.stringify(reportingCategory)));
    setInitialVariants(JSON.parse(JSON.stringify(variants)));
    setInitialImageState(JSON.parse(JSON.stringify(imageState)));
    setInitialExpiryDate(expiryDate ? new Date(expiryDate) : null);
    setHasUnsavedChanges(false);
    baselineReadyRef.current = true;
    setBaselineReady(true);
  }, [formState, toggles, selectors, reportingCategory, variants, imageState, expiryDate]);

  const currencySymbols = {
    GBP: "£",
    USD: "$",
    EUR: "€",
  };

  const getCurrencySymbol = (currencyCode) => {
    return currencySymbols[currencyCode] || currencyCode;
  };

  const toIntSafe = (value, fallback = 0) => {
    if (value === null || value === undefined || value === "") return fallback;
    const parsed = typeof value === "number" ? value : parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const toNullableIntSafe = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = typeof value === "number" ? value : parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const toBoolSafe = (value, fallback = false) => {
    if (value === null || value === undefined) return fallback;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "1") return true;
      if (normalized === "false" || normalized === "0") return false;
    }
    return fallback;
  };

  const normalizeBranchAssignment = (assignment) => {
    if (!assignment) return null;

    const normalized = {
      ...assignment,
      id: toIntSafe(assignment.id ?? assignment.ID),
      masterMenuItem_ID: toIntSafe(assignment.masterMenuItem_ID ?? assignment.MasterMenuItem_ID),
      masterCompID: toIntSafe(assignment.masterCompID ?? assignment.MasterCompID),
      branchCompID: toIntSafe(
        assignment.branchCompID ??
        assignment.BranchCompID ??
        assignment.branchCompId ??
        assignment.BranchCompId
      ),
      branchName:
        assignment.branchName ??
        assignment.BranchName ??
        assignment.compName ??
        assignment.CompName ??
        assignment.branchCompany?.compName ??
        assignment.branchCompany?.CompName ??
        "Branch",
      isAssigned: toBoolSafe(assignment.isAssigned ?? assignment.IsAssigned, false),
      isActive: toBoolSafe(assignment.isActive ?? assignment.IsActive, true),
      isPriceOverrideActive: toBoolSafe(
        assignment.isPriceOverrideActive ?? assignment.IsPriceOverrideActive,
        false
      ),
      branchPriceOverride:
        assignment.branchPriceOverride ?? assignment.BranchPriceOverride ?? null,
      branchDeliveryPriceOverride:
        assignment.branchDeliveryPriceOverride ?? assignment.BranchDeliveryPriceOverride ?? null,
      branchTakeAwayPriceOverride:
        assignment.branchTakeAwayPriceOverride ?? assignment.BranchTakeAwayPriceOverride ?? null,
      branchPublish:
        assignment.branchPublish ?? assignment.BranchPublish ?? null,
      branchOrderby: toNullableIntSafe(
        assignment.branchOrderby ?? assignment.BranchOrderby
      ),
    };

    return normalized;
  };

  const getBranchDisplayNameById = (branchCompID) => {
    const targetId = toIntSafe(branchCompID, 0);
    if (!targetId) return "";

    const match = (branchAssignments || []).find(
      (a) => toIntSafe(a?.branchCompID ?? a?.BranchCompID, 0) === targetId
    );

    return (
      match?.branchName ??
      match?.BranchName ??
      match?.compName ??
      match?.CompName ??
      match?.branchCompany?.compName ??
      match?.branchCompany?.CompName ??
      ""
    );
  };

  const fetchCompCurrency = useCallback(async () => {
    try {
      // First, try to get from Redux state
      if (hasProfileData) {
        setCompCurrency(profileCompCurrency || "GBP");
        return;
      }

      // If not in Redux, try to fetch from API
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_PROFILE);
        if (response.data?.data) {
          const currency = response.data.data.compCurrency || "GBP";
          setCompCurrency(currency);
          // Update Redux with fetched data
          dispatch(updateUserData({ profileData: response.data.data }));
          return;
        }
      } catch (apiErr) {
        console.error("Failed to fetch profile from API:", apiErr);
      }

      // If both fail, use default but don't show error toast on initial load
      setCompCurrency("GBP");
    } catch (err) {
      console.error("Error in fetchCompCurrency:", err);
      setCompCurrency("GBP"); // Use default instead of showing error
    }
  }, [hasProfileData, profileCompCurrency, dispatch]);

  const fetchSettings = useCallback(async () => {
    try {
      // First, try to get from Redux state
      if (hasSettingsData) {
        const newSettings = {
          s_VAT: settingsVat || 0,
          isTaxEnabled: settingsTaxEnabled ?? false,
        };
        setSettings(newSettings);
        return;
      }

      // If not in Redux, try to fetch from API
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_SETTINGS);
        if (response.data?.data) {
          const newSettings = {
            s_VAT: response.data.data.s_VAT || 0,
            isTaxEnabled: response.data.data.isTaxEnabled ?? false,
          };
          setSettings(newSettings);
          // Update Redux with fetched data
          dispatch(updateUserData({ settingsData: response.data.data }));
          return;
        }
      } catch (apiErr) {
        console.error("Failed to fetch settings from API:", apiErr);
      }

      // If both fail, use defaults but don't show error toast on initial load
      const defaultSettings = {
        s_VAT: 0,
        isTaxEnabled: false,
      };
      setSettings(defaultSettings);
    } catch (err) {
      console.error("Error in fetchSettings:", err);
      // Use defaults instead of showing error
      setSettings({
        s_VAT: 0,
        isTaxEnabled: false,
      });
    }
  }, [hasSettingsData, settingsVat, settingsTaxEnabled, dispatch]);

  const fetchAllergens = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        "/api/Allergen/GetAllAllergensGlobal"
      );
      setAllAllergens(response.data.data || []);
    } catch (err) {
      console.error("Error fetching allergens:", err);
      setAllAllergens([]);
      showErrorToast("Failed to fetch allergens");
    }
  }, []);

  // Fetch products for combo selection - use same API as Purchase Order to get variants with their titles
  const fetchProducts = useCallback(async () => {
    if (!CompID) return;
    try {
      const response = await axiosInstance.get(APIs.GET_ALL_PRODUCTS_FOR_PURCHASE_ORDER, {
        params: { CompID },
      });
      setProducts(response.data.data || response.data);
    } catch (err) {
      setProducts([]);
      showErrorToast("Failed to fetch products");
    }
  }, [CompID]);

  const fetchAllCategories = useCallback(async () => {
    if (!CompID) return;
    try {
      const response = await axiosInstance.get(APIs.GET_CATEGORIES, {
        params: {
          CompID,
          SortBy: "RootCat_Name",
          SortOrder: "ASC",
          Search: "",
        },
      });
      const categoryData = response.data.data || response.data;
      if (Array.isArray(categoryData)) {
        // Flatten categories including subcategories
        const flattenCategories = (categories) => {
          let result = [];
          categories.forEach(cat => {
            if (cat && !cat.isAddOnCategory) {
              result.push(cat);
              if (cat.subCategoriesList && cat.subCategoriesList.length > 0) {
                result = result.concat(flattenCategories(cat.subCategoriesList));
              }
            }
          });
          return result;
        };
        setAllCategories(flattenCategories(categoryData));
      } else {
        setAllCategories([]);
      }
    } catch (err) {
      setAllCategories([]);
      showErrorToast("Failed to fetch categories");
    } finally {
      setCategoriesLoaded(true);
    }
  }, [CompID]);

  const fetchUnits = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/Unit/SuperAdmin/GetAllUnits", {
        params: {
          SortBy: "MeasureName",
          SortOrder: "ASC",
          Search: "",
          PageSize: "1000",
          PageNumber: 1,
        },
      });

      if (response.data.status) {
        const unitsData = response.data.data || [];
        setUnits(Array.isArray(unitsData) ? unitsData : []);
      } else {
        console.error("Failed to fetch units:", response.data.Message);
        setUnits([]);
      }
    } catch (err) {
      console.error("Error fetching units:", err);
      setUnits([]);
    }
  }, []);

  const fetchItemDetails = useCallback(async () => {
    try {
      baselineReadyRef.current = false;
      setBaselineReady(false);
      setHasUnsavedChanges(false);
      setInitialLoading(true);

      const response = await axiosInstance.get(APIs.GET_ITEM_BY_ID, {
        params: { CompID, MenuItem_ID: itemId, IncludeArchived: includeArchived },
      });

      const itemData = response.data.data || response.data;
      const isCombo = itemData.menuItem_Type === "Combo" || isComboItem;

      // Check if this is a branch and the product belongs to parent company
      if (isBranchMode && itemData) {
        const itemCompID = itemData.CompID || itemData.compID;
        
        // If product's CompID matches parent CompID, it belongs to parent company
        if (itemCompID && parentCompID > 0 && parseInt(itemCompID) === parseInt(parentCompID)) {
          setIsParentCompanyProduct(true);
          showErrorToast("This product belongs to the parent company. Redirecting to branch edit page...");
          // Redirect to branch edit page immediately
          navigate(`/items/branchEditItem/${itemId}`);
          return;
        }
      }

      // Update isComboItem state based on actual item data
      setIsComboItem(isCombo);
      setIsParentCompanyProduct(false);

      const toStr = (v) => (v === null || v === undefined ? "" : String(v));
    const newFormState = {
        ...formState,
        localizeID: itemData.localizeID || itemData.LocalizeID || formState.localizeID || "en",
        menuItem_Name: itemData.menuItem_Name || "",
        menuItem_KitchenDisplayName: itemData.menuItem_KitchenDisplayName || "",
        menuItem_Detail: itemData.menuItem_Detail || "",
        menuItem_RootType: itemData.menuItem_RootType || ProductType || "",
        menuItem_ColorCode: itemData.menuItem_ColorCode || "",
        menuItem_SalePrice: toStr(itemData.menuItem_SalePrice),
        menuItem_CostPrice: toStr(itemData.menuItem_CostPrice),
        menuItem_TaxPercentage: itemData.isTaxExempt
          ? ""
          : toStr(itemData.menuItem_TaxPercentage) ||
          (settings.isTaxEnabled && settings.s_VAT
            ? settings.s_VAT.toString()
            : ""),
        menuItem_TakeAwayPrice: toStr(itemData.menuItem_TakeAwayPrice),
        menuItem_DeliveryPrice: toStr(itemData.menuItem_DeliveryPrice),
        menuItem_ServingSize: toStr(itemData.menuItem_ServingSize),
        menuItem_PreparationTime: toStr(itemData.menuItem_PreparationTime),
        menuItem_SKU: itemData.menuItem_SKU || "",
        menuItem_SEOTitle: itemData.menuItem_SEOTitle || "",
        menuItem_SEODescription: itemData.menuItem_SEODescription || "",
        menuItem_Permalink: itemData.menuItem_Permalink || "",
        menuItem_ASTime: itemData.menuItem_ASTime || "",
        menuItem_AETime: itemData.menuItem_AETime || "",
        menuItem_Rating: toStr(itemData.menuItem_Rating),
        menuItem_BarCode: itemData.menuItem_BarCode || "",
        menuItem_Type: isCombo ? "Combo" : "Product",
        menuItem_ImageAltText: itemData.menuItem_ImageAltText || "",
        retail_Markup: toStr(itemData.retail_Markup),
        delivery_Markup: toStr(itemData.delivery_Markup),
        online_Markup: toStr(itemData.online_Markup),
        current_Quantity: toStr(itemData.current_Quantity),
        reorder_Quantity: toStr(itemData.reorder_Quantity),
        reorder_Level: toStr(itemData.reorder_Level),
        availableQuantity: toStr(itemData.availableQuantity),
        orderQuantityLimit: toStr(itemData.orderQuantityLimit),
        menuItem_MeasurementType: itemData.menuItem_MeasurementType || "",
        menuItem_DefaultSize: toStr(itemData.menuItem_DefaultSize),
        menuItem_DefaultSizeUnit: itemData.menuItem_DefaultSizeUnit || "",
        menuItem_ContainerType: itemData.menuItem_ContainerType || "",
        menuitem_DefaultSizeInBaseUnit: Number(itemData.menuitem_DefaultSizeInBaseUnit) || 0,
        menuItem_RecipeType: itemData.menuItem_RecipeType ?? itemData.MenuItem_RecipeType ?? "Made to order",
        reportCat_ID: itemData.reportCat_ID || "",
      };
      setFormState(newFormState);
      setInitialFormState(JSON.parse(JSON.stringify(newFormState)));

      const hasVariantFlag = !!(
        itemData.menuItem_HasVariant || itemData.MenuItem_HasVariant
      );
      const isSellingFlag = !!(
        itemData.menuItem_IsSellingProduct ||
        itemData.MenuItem_IsSellingProduct ||
        hasVariantFlag
      );
      const newToggles = {
        menuItem_Publish: itemData.menuItem_Publish || false,
        is_ShowInKiosk: itemData.is_ShowInKiosk || false,
        isSellOnTill: itemData.isSellOnTill || false,
        isActiveMobileApp: itemData.isActiveMobileApp || false,
        is_OutOfStock: itemData.is_OutOfStock || false,
        skuEnabled: !!itemData.menuItem_SKU,
        expiryDateEnabled:
          itemData.menuItem_ExpiryDate &&
          itemData.menuItem_ExpiryDate !== "0001-01-01T00:00:00",
        seoEnabled: true,
        modifierGroupsEnabled: itemData.modifierGroups?.length > 0 || false,
        allergensEnabled: itemData.hasAllergen || false,
        menuGroupsEnabled: itemData.menuGroups?.length > 0 || false,
        productsEnabled: isCombo,
        menuItem_Homefeatured: itemData.menuItem_Homefeatured || false,
        menuItem_featured: itemData.menuItem_featured || false,
        menuItem_IsModifier: itemData.menuItem_IsModifier && !isSellingFlag || false,
        menuItem_IsFavorite: itemData.menuItem_IsFavorite || false,
        menuItem_HasVariant: hasVariantFlag,
        isArchieve: itemData.isArchieve || false,
        isAllowedtoSetPriceatThePointofSale:
          itemData.isAllowedtoSetPriceatThePointofSale || false,
        isTaxExempt: itemData.isTaxExempt || false,
        isPreventGainingLoyalty: itemData.isPreventGainingLoyalty || false,
        isHaveCustomerSpecificPricing: itemData.isHaveCustomerSpecificPricing || false,
        isProductisScannableOnly: itemData.isProductisScannableOnly || false,
        isMasterProduct: itemData.isMasterProduct || false,
        itHasAMasterProduct: itemData.itHasAMasterProduct || false,
        menuItem_IsDefaultModifier: itemData.menuItem_IsDefaultModifier || false,
        isShowNotificationExpDate: itemData.isShowNotificationExpDate || false,
        isShowSocialMediaLink: itemData.isShowSocialMediaLink || false,
        menuItem_SellingMethodBoth: itemData.menuItem_SellingMethodBoth || false,
        // Variant parents are selling products; older rows may have IsSellingProduct=0
        menuItem_IsSellingProduct: isSellingFlag,
      };
      setToggles(newToggles);
      setInitialToggles(JSON.parse(JSON.stringify(newToggles)));

      const newImageState = {
        menuItem_Image: itemData.menuItem_Image || "",
        imageFile: null,
      };
      setImageState(newImageState);
      setInitialImageState(JSON.parse(JSON.stringify(newImageState)));

      const newSelectors = {
        ...selectors,
        selectedParentCategory: itemData.categories || [],
        selectedModifierGroups: itemData.modifierGroups || [],
        selectedAllergens: itemData.allergens
          ? (() => {
            // Split by comma, trim whitespace, filter empty strings, and remove duplicates
            const allergenNames = itemData.allergens
              .split(",")
              .map(name => name.trim())
              .filter(name => name.length > 0);

            // Remove duplicates (case-insensitive)
            const uniqueNames = [];
            const seenNames = new Set();
            for (const name of allergenNames) {
              const lowerName = name.toLowerCase();
              if (!seenNames.has(lowerName)) {
                seenNames.add(lowerName);
                uniqueNames.push(name);
              }
            }

            // Map to allergen objects
            return uniqueNames.map((name) => {
              const foundAllergen = allAllergens.find(
                (allergen) => allergen.allergen_Name.toLowerCase() === name.toLowerCase()
              );
              return foundAllergen || { id: null, allergen_Name: name };
            });
          })()
          : [],
        selectedMenuGroups: itemData.menuGroups || [],
        selectedProducts: isCombo
          ? (itemData.Products || itemData.products || []).map((product) => ({
            ...product,
            availableQuantity: product.ItemQuantity || product.availableQuantity || product.itemQuantity || "1",
          }))
          : [],
      };
      setSelectors(newSelectors);
      setInitialSelectors(JSON.parse(JSON.stringify(newSelectors)));

      // Load reporting category - On UPDATE page: Only load what's saved in DB, don't auto-set to first category
      let newReportingCategory = {};
      if (itemData.reportCat_ID) {
        const reportCatId = Number(itemData.reportCat_ID);
        const matchesReportCat = (cat) =>
          cat &&
          (Number(cat.rootCat_ID) === reportCatId ||
            Number(cat.rC_ID) === reportCatId);

        // Try selected categories first
        let reportingCat = itemData.categories?.find(matchesReportCat);

        if (reportingCat) {
          newReportingCategory = reportingCat;
        } else {
          // Will be resolved by useEffect when allCategories loads
          newReportingCategory = {
            rootCat_ID: itemData.reportCat_ID,
            rC_ID: itemData.reportCat_ID,
          };
        }
      }
      setReportingCategory(newReportingCategory);
      setInitialReportingCategory(JSON.parse(JSON.stringify(newReportingCategory)));

      let newVariants = [];
      if (itemData.menuItem_HasVariant) {
        const rawProducts = itemData.products || itemData.Products || [];
        const existingVariants = Array.isArray(rawProducts)
          ? rawProducts.map((variant) => {
            const measurementType = itemData.menuItem_MeasurementType || "";
            const rawUnit =
              variant?.menuItem_DefaultSizeUnit ??
              variant?.MenuItem_DefaultSizeUnit ??
              variant?.defaultSizeUnit ??
              variant?.DefaultSizeUnit ??
              "";
            
            return {
              ...variant,
              menuItem_IsDefaultVariant: !!(
                variant?.menuItem_IsDefaultVariant ??
                variant?.MenuItem_IsDefaultVariant
              ),
              reportCat_ID: itemData.reportCat_ID || "",
              menuItem_MeasurementType: measurementType,
              menuItem_DefaultSize:
                variant?.menuItem_DefaultSize ??
                variant?.MenuItem_DefaultSize ??
                variant?.defaultSize ??
                variant?.DefaultSize ??
                "",
              menuItem_DefaultSizeUnit: rawUnit,
              menuitem_DefaultSizeInBaseUnit:
                variant?.menuitem_DefaultSizeInBaseUnit ??
                variant?.Menuitem_DefaultSizeInBaseUnit ??
                variant?.menuItem_DefaultSizeInBaseUnit ??
                0,
              menuItem_CostPrice: toStr(variant?.menuItem_CostPrice ?? variant?.MenuItem_CostPrice),
              menuItem_SalePrice: toStr(variant?.menuItem_SalePrice ?? variant?.MenuItem_SalePrice),
              menuItem_TaxPercentage: toStr(variant?.menuItem_TaxPercentage ?? variant?.MenuItem_TaxPercentage),
              menuItem_DeliveryPrice: toStr(variant?.menuItem_DeliveryPrice ?? variant?.MenuItem_DeliveryPrice),
              menuItem_TakeAwayPrice: toStr(variant?.menuItem_TakeAwayPrice ?? variant?.MenuItem_TakeAwayPrice),
            };
          })
          : [];
        newVariants = [...existingVariants, { ...Modifier, menuItem_SellingMethodBoth: false, reportCat_ID: itemData.reportCat_ID || "" }];
      } else {
        newVariants = [{ ...Modifier, menuItem_SellingMethodBoth: false, reportCat_ID: itemData.reportCat_ID || "" }];
      }
      setVariants(newVariants);
      setInitialVariants(JSON.parse(JSON.stringify(newVariants)));

      const newExpiryDate = itemData.menuItem_ExpiryDate &&
        itemData.menuItem_ExpiryDate !== "0001-01-01T00:00:00"
        ? new Date(itemData.menuItem_ExpiryDate)
        : null;
      setExpiryDate(newExpiryDate);
      setInitialExpiryDate(newExpiryDate ? new Date(newExpiryDate) : null);

      setHasUserEditedTax(false);
    } catch (error) {
      showErrorToast("Failed to load item details");
    } finally {
      setInitialLoading(false);
    }
  }, [CompID, itemId, ProductType, isComboItem, settings, allAllergens, isBranchMode, parentCompID, navigate, includeArchived]);

  // Capture baseline AFTER load + post-load hydration effects settle.
  // Until then, treat the page as clean so tab switches don't show a false save/discard modal.
  useEffect(() => {
    if (initialLoading) {
      baselineReadyRef.current = false;
      setBaselineReady(false);
      setHasUnsavedChanges(false);
      return;
    }

    if (baselineReadyRef.current) return;

    const reportCatId =
      formState.reportCat_ID ||
      reportingCategory?.rootCat_ID ||
      reportingCategory?.rC_ID;
    const reportCatResolved =
      !reportCatId ||
      !!(reportingCategory?.rootCat_Name || reportingCategory?.rC_Name) ||
      categoriesLoaded;

    if (!reportCatResolved) return;

    const timer = setTimeout(() => {
      if (baselineReadyRef.current) return;
      captureBaselineSnapshot();
    }, 350);

    return () => clearTimeout(timer);
  }, [
    initialLoading,
    categoriesLoaded,
    formState,
    toggles,
    selectors,
    reportingCategory,
    variants,
    imageState,
    expiryDate,
    units,
    allAllergens,
    captureBaselineSnapshot,
  ]);

  // Check for unsaved changes only after baseline snapshot is ready
  useEffect(() => {
    if (!baselineReady || !initialFormState || !initialToggles || !initialSelectors) {
      setHasUnsavedChanges(false);
      return;
    }

    const formChanged = stableStringify(formState) !== stableStringify(initialFormState);
    const togglesChanged = stableStringify(toggles) !== stableStringify(initialToggles);
    const selectorsChanged = stableStringify(selectors) !== stableStringify(initialSelectors);
    const reportingCategoryChanged = stableStringify(reportingCategory) !== stableStringify(initialReportingCategory);
    const variantsChanged = stableStringify(variants) !== stableStringify(initialVariants);
    const imageChanged = stableStringify(imageState) !== stableStringify(initialImageState);
    const expiryDateChanged = expiryDate?.getTime() !== initialExpiryDate?.getTime();

    setHasUnsavedChanges(
      formChanged ||
      togglesChanged ||
      selectorsChanged ||
      reportingCategoryChanged ||
      variantsChanged ||
      imageChanged ||
      expiryDateChanged
    );
  }, [baselineReady, formState, toggles, selectors, reportingCategory, variants, imageState, expiryDate, initialFormState, initialToggles, initialSelectors, initialReportingCategory, initialVariants, initialImageState, initialExpiryDate]);

  // Fetch existing branch assignments
  const fetchBranchAssignments = useCallback(async () => {
    if (!CompID || !itemId || !isParentBranch) return;
    try {
      const response = await axiosInstance.get(
        `${APIs.GET_ASSIGNED_BRANCHES_FOR_PRODUCT}/${itemId}/${CompID}`
      );
      if (response.data && response.data.data) {
        const assignments = (Array.isArray(response.data.data) ? response.data.data : [])
          .map(normalizeBranchAssignment)
          .filter(Boolean);
        setBranchAssignments(assignments);

        const assignedBranches = assignments
          .filter((a) => a.isAssigned)
          .map((a) => ({
            CompID: a.branchCompID,
            CompName: a.branchName || "Branch",
          }));
        setSelectedBranches(assignedBranches);
      }
    } catch (err) {
      // Silent fail - product might not have assignments yet
    }
  }, [CompID, itemId, isParentBranch]);

  // For variant products, build per-branch per-variant rows for display (no main-product row)
  useEffect(() => {
    const fetchVariantOverridesForBranches = async () => {
      if (!isParentBranch || !toggles.menuItem_HasVariant) {
        setBranchVariantOverrideRows([]);
        return;
      }

      const assigned = (branchAssignments || []).filter((a) => a?.isAssigned);
      if (assigned.length === 0) {
        setBranchVariantOverrideRows([]);
        return;
      }

      const toInt = (v) => {
        if (v === null || v === undefined) return 0;
        const n = typeof v === "number" ? v : parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
      };

      try {
        setLoadingBranchVariantOverrides(true);
        const results = await Promise.allSettled(
          assigned.map(async (a) => {
            const branchCompId = a.branchCompID ?? a.BranchCompID;
            const response = await axiosInstance.get(APIs.GET_PRODUCT_WITH_VARIANTS_BY_BRANCH, {
              params: {
                branchCompId,
                parentCompId: CompID,
                masterMenuItemId: itemId,
              },
            });

            const payload = response.data?.data || {};
            const variantsPayload = payload.variants ?? payload.Variants ?? [];
            const list = Array.isArray(variantsPayload) ? variantsPayload : [];

            return {
              branchCompId,
              branchName:
                a.branchName ??
                a.BranchName ??
                a.compName ??
                a.CompName ??
                a.branchCompany?.compName ??
                a.branchCompany?.CompName ??
                "Branch",
              variants: list.map((v) => {
                const vid = toInt(v?.menuItem_ID ?? v?.MenuItem_ID);
                return {
                  branchCompId,
                  branchName:
                    a.branchName ??
                    a.BranchName ??
                    a.compName ??
                    a.CompName ??
                    a.branchCompany?.compName ??
                    a.branchCompany?.CompName ??
                    "Branch",
                  variantId: vid,
                  variantName: v?.menuItem_Name ?? v?.MenuItem_Name ?? "",
                  variantTitle: v?.menuItem_DefaultVariantTitle ?? v?.MenuItem_DefaultVariantTitle ?? "",
                  // Branch meta
                  branchAssignmentID: v?.branchAssignmentID ?? v?.BranchAssignmentID ?? null,
                  isPriceOverrideActive:
                    v?.branchIsPriceOverrideActive ?? v?.BranchIsPriceOverrideActive ?? false,
                  branchPriceOverride: v?.branchPriceOverride ?? v?.BranchPriceOverride ?? null,
                  branchDeliveryPriceOverride:
                    v?.branchDeliveryPriceOverride ?? v?.BranchDeliveryPriceOverride ?? null,
                  branchTakeAwayPriceOverride:
                    v?.branchTakeAwayPriceOverride ?? v?.BranchTakeAwayPriceOverride ?? null,
                  branchPublish: v?.branchPublish ?? v?.BranchPublish ?? null,
                  branchOrderby: v?.branchOrderby ?? v?.BranchOrderby ?? null,
                  // Master prices (for effective display)
                  menuItem_SalePrice: v?.menuItem_SalePrice ?? v?.MenuItem_SalePrice ?? 0,
                  menuItem_DeliveryPrice: v?.menuItem_DeliveryPrice ?? v?.MenuItem_DeliveryPrice ?? 0,
                  menuItem_TakeAwayPrice: v?.menuItem_TakeAwayPrice ?? v?.MenuItem_TakeAwayPrice ?? 0,
                };
              }),
            };
          })
        );

        const rows = results
          .filter((r) => r.status === "fulfilled")
          .flatMap((r) => (r.value?.variants || []))
          .filter((r) => r.variantId > 0);

        // Only show variants that are assigned (expectation: variants auto-follow parent)
        setBranchVariantOverrideRows(rows);
      } catch (err) {
        setBranchVariantOverrideRows([]);
      } finally {
        setLoadingBranchVariantOverrides(false);
      }
    };

    fetchVariantOverridesForBranches();
  }, [isParentBranch, toggles.menuItem_HasVariant, branchAssignments, CompID, itemId]);

  const openBranchOverrideModal = async (assignment) => {
    if (!assignment) return;

    setEditingBranchAssignment(assignment);
    setBranchOverrideModalOpen(true);

    // If item has variants, load + edit variant overrides for this branch (no main-product entry)
    if (!!toggles.menuItem_HasVariant) {
      setIsVariantBranchOverrideMode(true);
      setVariantBranchOverrideItems([]);
      setVariantBranchOverrideForms({});

      const getPublishMode = (v) => {
        if (v === null || v === undefined) return "inherit";
        return v ? "publish" : "unpublish";
      };

      const toInt = (v) => {
        if (v === null || v === undefined) return 0;
        const n = typeof v === "number" ? v : parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
      };

      try {
        setLoading(true);
        const branchCompId = assignment.branchCompID ?? assignment.BranchCompID ?? assignment.branchCompId ?? assignment.BranchCompId;
        const response = await axiosInstance.get(APIs.GET_PRODUCT_WITH_VARIANTS_BY_BRANCH, {
          params: {
            branchCompId,
            parentCompId: CompID,
            masterMenuItemId: itemId,
          },
        });

        const payload = response.data?.data || {};
        const variantsPayload = payload.variants ?? payload.Variants ?? [];
        const list = Array.isArray(variantsPayload) ? variantsPayload : [];
        setVariantBranchOverrideItems(list);

        const forms = {};
        list.forEach((v) => {
          const vid = toInt(v?.menuItem_ID ?? v?.MenuItem_ID);
          if (!vid) return;
          const branchPublish = v?.branchPublish ?? v?.BranchPublish;
          forms[vid] = {
            branchPublishMode: getPublishMode(branchPublish),
            branchOrderby: v?.branchOrderby ?? v?.BranchOrderby ?? "",
            isPriceOverrideActive: v?.branchIsPriceOverrideActive ?? v?.BranchIsPriceOverrideActive ?? false,
            branchPriceOverride: v?.branchPriceOverride ?? v?.BranchPriceOverride ?? "",
            branchDeliveryPriceOverride: v?.branchDeliveryPriceOverride ?? v?.BranchDeliveryPriceOverride ?? "",
            branchTakeAwayPriceOverride: v?.branchTakeAwayPriceOverride ?? v?.BranchTakeAwayPriceOverride ?? "",
          };
        });
        setVariantBranchOverrideForms(forms);
      } catch (err) {
        showErrorToast(err?.response?.data?.message || "Failed to load variants for branch overrides.");
      } finally {
        setLoading(false);
      }

      return;
    }

    // Non-variant item: keep existing single-product branch override form
    setIsVariantBranchOverrideMode(false);
    const publishMode =
      assignment.branchPublish === null || assignment.branchPublish === undefined
        ? "inherit"
        : assignment.branchPublish
          ? "publish"
          : "unpublish";

    setBranchOverrideForm({
      branchPublishMode: publishMode,
      branchOrderby: assignment.branchOrderby ?? "",
      isPriceOverrideActive: assignment.isPriceOverrideActive ?? false,
      branchPriceOverride: assignment.branchPriceOverride ?? "",
      branchDeliveryPriceOverride: assignment.branchDeliveryPriceOverride ?? "",
      branchTakeAwayPriceOverride: assignment.branchTakeAwayPriceOverride ?? "",
    });
  };

  const closeBranchOverrideModal = () => {
    setBranchOverrideModalOpen(false);
    setEditingBranchAssignment(null);
    setIsVariantBranchOverrideMode(false);
    setVariantBranchOverrideItems([]);
    setVariantBranchOverrideForms({});
  };

  const saveBranchOverrideFromParent = async () => {
    if (!editingBranchAssignment?.id) {
      showErrorToast("Branch assignment not found.");
      return;
    }

    // Variant mode: update overrides per variant for this branch (no main-product entry)
    if (isVariantBranchOverrideMode) {
      const toInt = (v) => {
        if (v === null || v === undefined) return 0;
        const n = typeof v === "number" ? v : parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
      };

      const parseNullableFloat = (v) => {
        if (v === "" || v === null || v === undefined) return null;
        const n = typeof v === "number" ? v : parseFloat(v);
        return Number.isFinite(n) ? n : null;
      };

      const branchCompId = editingBranchAssignment.branchCompID ?? editingBranchAssignment.BranchCompID;
      const tasks = [];
      const skipped = [];

      for (const v of variantBranchOverrideItems) {
        const vid = toInt(v?.menuItem_ID ?? v?.MenuItem_ID);
        if (!vid) continue;

        const assignmentId = v?.branchAssignmentID ?? v?.BranchAssignmentID;
        if (!assignmentId) {
          skipped.push(vid);
          continue;
        }

        const form = variantBranchOverrideForms[vid] || {};

        const isPublishInherit = form.branchPublishMode === "inherit";
        const branchPublish = isPublishInherit ? null : form.branchPublishMode === "publish";

        const isOrderInherit = form.branchOrderby === "" || form.branchOrderby === null || form.branchOrderby === undefined;
        const branchOrderby = isOrderInherit ? null : parseInt(form.branchOrderby, 10);

        const payload = {
          ID: assignmentId,
          MasterMenuItem_ID: vid,
          MasterCompID: CompID,
          BranchCompID: branchCompId,
          IsAssigned: true,
          IsActive: v?.branchAssignmentIsActive ?? v?.BranchAssignmentIsActive ?? true,
          AssignedBy: assignedBy || "System",

          IsPriceOverrideActive: !!form.isPriceOverrideActive,
          BranchPriceOverride: parseNullableFloat(form.branchPriceOverride),
          BranchDeliveryPriceOverride: parseNullableFloat(form.branchDeliveryPriceOverride),
          BranchTakeAwayPriceOverride: parseNullableFloat(form.branchTakeAwayPriceOverride),
          BranchPublish: branchPublish,
          BranchOrderby: Number.isFinite(branchOrderby) ? branchOrderby : null,

          ClearBranchPublish: isPublishInherit,
          ClearBranchOrderby: isOrderInherit,
          ClearBranchPriceOverride:
            !form.isPriceOverrideActive || form.branchPriceOverride === "" || form.branchPriceOverride === null,
          ClearBranchDeliveryPriceOverride:
            !form.isPriceOverrideActive || form.branchDeliveryPriceOverride === "" || form.branchDeliveryPriceOverride === null,
          ClearBranchTakeAwayPriceOverride:
            !form.isPriceOverrideActive || form.branchTakeAwayPriceOverride === "" || form.branchTakeAwayPriceOverride === null,
        };

        tasks.push(axiosInstance.put(APIs.PUT_UPDATE_BRANCH_ASSIGNMENT, payload));
      }

      try {
        setLoading(true);
        const results = await Promise.allSettled(tasks);
        const failed = results.filter((r) => r.status === "rejected");

        if (failed.length === 0) {
          showSuccessToast(skipped.length > 0 ? "Variant overrides saved (some variants were skipped)." : "Variant overrides saved.");
          closeBranchOverrideModal();
          fetchBranchAssignments();
        } else {
          showErrorToast(`Failed to update ${failed.length} variant override(s).`);
        }
      } catch (err) {
        showErrorToast(err.response?.data?.message || "Failed to update variant overrides.");
      } finally {
        setLoading(false);
      }

      return;
    }

    const isPublishInherit = branchOverrideForm.branchPublishMode === "inherit";
    const branchPublish = isPublishInherit ? null : branchOverrideForm.branchPublishMode === "publish";

    const isOrderInherit =
      branchOverrideForm.branchOrderby === "" || branchOverrideForm.branchOrderby === null || branchOverrideForm.branchOrderby === undefined;
    const branchOrderby = isOrderInherit ? null : parseInt(branchOverrideForm.branchOrderby, 10);

    const parseNullableFloat = (v) => {
      if (v === "" || v === null || v === undefined) return null;
      const n = typeof v === "number" ? v : parseFloat(v);
      return Number.isFinite(n) ? n : null;
    };

    try {
      setLoading(true);
      const payload = {
        ID: editingBranchAssignment.id,
        MasterMenuItem_ID: editingBranchAssignment.masterMenuItem_ID,
        MasterCompID: editingBranchAssignment.masterCompID,
        BranchCompID: editingBranchAssignment.branchCompID,
        IsAssigned: true,
        IsActive: editingBranchAssignment.isActive ?? true,
        AssignedBy: assignedBy || "System",

        IsPriceOverrideActive: !!branchOverrideForm.isPriceOverrideActive,
        BranchPriceOverride: parseNullableFloat(branchOverrideForm.branchPriceOverride),
        BranchDeliveryPriceOverride: parseNullableFloat(branchOverrideForm.branchDeliveryPriceOverride),
        BranchTakeAwayPriceOverride: parseNullableFloat(branchOverrideForm.branchTakeAwayPriceOverride),
        BranchPublish: branchPublish,
        BranchOrderby: Number.isFinite(branchOrderby) ? branchOrderby : null,

        // Clear flags for reset-to-inherit
        ClearBranchPublish: isPublishInherit,
        ClearBranchOrderby: isOrderInherit,
        ClearBranchPriceOverride:
          !branchOverrideForm.isPriceOverrideActive || branchOverrideForm.branchPriceOverride === "" || branchOverrideForm.branchPriceOverride === null,
        ClearBranchDeliveryPriceOverride:
          !branchOverrideForm.isPriceOverrideActive || branchOverrideForm.branchDeliveryPriceOverride === "" || branchOverrideForm.branchDeliveryPriceOverride === null,
        ClearBranchTakeAwayPriceOverride:
          !branchOverrideForm.isPriceOverrideActive || branchOverrideForm.branchTakeAwayPriceOverride === "" || branchOverrideForm.branchTakeAwayPriceOverride === null,
      };

      const response = await axiosInstance.put(APIs.PUT_UPDATE_BRANCH_ASSIGNMENT, payload);
      const isSuccess = response?.data?.status ?? response?.data?.Status;
      if (isSuccess) {
        showSuccessToast("Branch overrides updated.");
        closeBranchOverrideModal();
        await fetchBranchAssignments();
      } else {
        showErrorToast(response?.data?.message || response?.data?.Message || "Failed to update branch overrides.");
      }
    } catch (err) {
      showErrorToast(err.response?.data?.message || "Failed to update branch overrides.");
    } finally {
      setLoading(false);
    }
  };

  const resetBranchOverrideFromParent = async (assignment) => {
    if (!assignment?.id) {
      showErrorToast("Branch assignment not found.");
      return;
    }

    const confirm = await swal({
      title: "Reset branch overrides?",
      text: "This will reset publish, sort order and price overrides back to inherit (master values).",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    // Variant mode: reset all variant overrides for this branch (no main-product entry)
    if (!!toggles.menuItem_HasVariant) {
      const toInt = (v) => {
        if (v === null || v === undefined) return 0;
        const n = typeof v === "number" ? v : parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
      };

      try {
        setLoading(true);
        const branchCompId = assignment.branchCompID ?? assignment.BranchCompID;
        const response = await axiosInstance.get(APIs.GET_PRODUCT_WITH_VARIANTS_BY_BRANCH, {
          params: {
            branchCompId,
            parentCompId: CompID,
            masterMenuItemId: itemId,
          },
        });
        const payload = response.data?.data || {};
        const variantsPayload = payload.variants ?? payload.Variants ?? [];
        const list = Array.isArray(variantsPayload) ? variantsPayload : [];

        const tasks = [];
        for (const v of list) {
          const vid = toInt(v?.menuItem_ID ?? v?.MenuItem_ID);
          if (!vid) continue;
          const assignmentId = v?.branchAssignmentID ?? v?.BranchAssignmentID;
          if (!assignmentId) continue;

          tasks.push(
            axiosInstance.put(APIs.PUT_UPDATE_BRANCH_ASSIGNMENT, {
              ID: assignmentId,
              MasterMenuItem_ID: vid,
              MasterCompID: CompID,
              BranchCompID: branchCompId,
              IsAssigned: true,
              IsActive: v?.branchAssignmentIsActive ?? v?.BranchAssignmentIsActive ?? true,

              IsPriceOverrideActive: false,
              BranchPriceOverride: null,
              BranchDeliveryPriceOverride: null,
              BranchTakeAwayPriceOverride: null,
              BranchPublish: null,
              BranchOrderby: null,

              ClearBranchPublish: true,
              ClearBranchOrderby: true,
              ClearBranchPriceOverride: true,
              ClearBranchDeliveryPriceOverride: true,
              ClearBranchTakeAwayPriceOverride: true,
              AssignedBy: assignedBy || "System",
            })
          );
        }

        const results = await Promise.allSettled(tasks);
        const failed = results.filter((r) => r.status === "rejected");
        if (failed.length === 0) {
          showSuccessToast("Variant overrides reset to inherit.");
          fetchBranchAssignments();
        } else {
          showErrorToast(`Failed to reset ${failed.length} variant override(s).`);
        }
      } catch (err) {
        showErrorToast(err.response?.data?.message || "Failed to reset variant overrides.");
      } finally {
        setLoading(false);
      }

      return;
    }

    try {
      setLoading(true);
      const payload = {
        ID: assignment.id,
        MasterMenuItem_ID: assignment.masterMenuItem_ID,
        MasterCompID: assignment.masterCompID,
        BranchCompID: assignment.branchCompID,
        IsAssigned: true,
        IsActive: assignment.isActive ?? true,

        // Ensure pricing follows master
        IsPriceOverrideActive: false,
        BranchPriceOverride: null,
        BranchDeliveryPriceOverride: null,
        BranchTakeAwayPriceOverride: null,
        BranchPublish: null,
        BranchOrderby: null,

        // Clear flags for reset-to-inherit
        ClearBranchPublish: true,
        ClearBranchOrderby: true,
        ClearBranchPriceOverride: true,
        ClearBranchDeliveryPriceOverride: true,
        ClearBranchTakeAwayPriceOverride: true,
        AssignedBy: assignedBy || "System",
      };

      const response = await axiosInstance.put(APIs.PUT_UPDATE_BRANCH_ASSIGNMENT, payload);
      const isSuccess = response?.data?.status ?? response?.data?.Status;
      if (isSuccess) {
        showSuccessToast("Branch overrides reset to inherit.");
        await fetchBranchAssignments();
      } else {
        showErrorToast(response?.data?.message || response?.data?.Message || "Failed to reset branch overrides.");
      }
    } catch (err) {
      showErrorToast(err.response?.data?.message || "Failed to reset branch overrides.");
    } finally {
      setLoading(false);
    }
  };

  const saveBranchAssignmentsFromSection = async () => {
    if (!isParentBranch || !CompID || !itemId) {
      showErrorToast("Branch assignment save is not available for this item.");
      return false;
    }

    const selectedIds = Array.from(
      new Set(
        (selectedBranches || [])
          .map((b) => {
            if (typeof b === "number") return parseInt(b, 10);
            const id = b?.CompID ?? b?.compID ?? b?.branchCompID ?? b?.BranchCompID;
            return id ? parseInt(id, 10) : null;
          })
          .filter((id) => id !== null && !isNaN(id) && id > 0)
      )
    );

    const currentAssignedIds = Array.from(
      new Set(
        (branchAssignments || [])
          .filter((a) => !!a?.isAssigned)
          .map((a) => {
            const id = a?.branchCompID ?? a?.BranchCompID ?? a?.branchCompId ?? a?.BranchCompId;
            return id ? parseInt(id, 10) : null;
          })
          .filter((id) => id !== null && !isNaN(id) && id > 0)
      )
    );

    const toAssign = selectedIds.filter((id) => !currentAssignedIds.includes(id));
    const toUnassign = currentAssignedIds.filter((id) => !selectedIds.includes(id));

    if (toAssign.length === 0 && toUnassign.length === 0) {
      showSuccessToast("No branch assignment changes to save.");
      return true;
    }

    const actionText = [
      toAssign.length > 0 ? `${toAssign.length} assign` : null,
      toUnassign.length > 0 ? `${toUnassign.length} unassign` : null,
    ]
      .filter(Boolean)
      .join(", ");

    const confirm = await swal({
      title: "Save branch assignment changes?",
      text: `This will apply: ${actionText}.`,
      icon: "warning",
      buttons: true,
      dangerMode: toUnassign.length > 0,
    });
    if (!confirm) return false;

    const unassignWarnings = [];

    try {
      setBranchManagementSaving(true);

      if (toAssign.length > 0) {
        await axiosInstance.post(APIs.POST_ASSIGN_PRODUCT_TO_BRANCHES, {
          MasterMenuItem_ID: parseInt(itemId, 10),
          ParentCompID: parseInt(CompID, 10),
          BranchCompIDs: toAssign,
        });
      }

      if (toUnassign.length > 0) {
        const results = await Promise.allSettled(
          toUnassign.map((branchCompId) =>
            axiosInstance.delete(APIs.DELETE_UNASSIGN_PRODUCT_FROM_BRANCH, {
              params: {
                masterMenuItemId: parseInt(itemId, 10),
                parentCompId: parseInt(CompID, 10),
                branchCompId,
              },
            })
          )
        );

        results.forEach((result, idx) => {
          if (result.status === "rejected") {
            const branchId = toUnassign[idx];
            const branchName = getBranchDisplayNameById(branchId) || `Branch ${branchId}`;
            const message =
              result.reason?.response?.data?.message ||
              result.reason?.message ||
              "Failed to unassign branch.";
            unassignWarnings.push(`${branchName}: ${message}`);
          }
        });
      }

      const refreshedResponse = await axiosInstance.get(
        `${APIs.GET_ASSIGNED_BRANCHES_FOR_PRODUCT}/${itemId}/${CompID}`
      );
      const refreshedAssignments = (Array.isArray(refreshedResponse?.data?.data) ? refreshedResponse.data.data : [])
        .map(normalizeBranchAssignment)
        .filter(Boolean);
      setBranchAssignments(refreshedAssignments);
      setSelectedBranches(
        refreshedAssignments
          .filter((a) => a.isAssigned)
          .map((a) => ({
            CompID: a.branchCompID,
            CompName: a.branchName || "Branch",
          }))
      );

      const stillAssignedAfterSave = new Set(
        refreshedAssignments
          .filter((a) => !!a?.isAssigned)
          .map((a) => toIntSafe(a?.branchCompID ?? a?.BranchCompID, 0))
          .filter((id) => id > 0)
      );

      toUnassign
        .filter((id) => stillAssignedAfterSave.has(id))
        .forEach((branchId) => {
          const alreadyExists = unassignWarnings.some((w) => w.includes(`Branch ${branchId}`) || w.includes(getBranchDisplayNameById(branchId)));
          if (!alreadyExists) {
            const branchName = getBranchDisplayNameById(branchId) || `Branch ${branchId}`;
            unassignWarnings.push(`${branchName}: Cannot unassign product. Branch has stock.`);
          }
        });

      if (unassignWarnings.length > 0) {
        await swal({
          title: "Branch assignment warnings",
          text: unassignWarnings.join("\n"),
          icon: "warning",
        });
      } else {
        showSuccessToast("Branch assignments saved.");
      }
      return true;
    } catch (err) {
      showErrorToast(err?.response?.data?.message || "Failed to save branch assignments.");
      return false;
    } finally {
      setBranchManagementSaving(false);
    }
  };

  // Check if company has branches (only show branch UI if branches exist)
  useEffect(() => {
    const checkParentBranch = async () => {
      if (!CompID) return;
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_LOCATIONS, {
          params: { CompID },
        });
        const branches = response.data?.data || [];
        // Normalize types/casing because APIs may return string IDs or camelCase fields.
        const toInt = (v) => {
          if (v === null || v === undefined) return null;
          const n = typeof v === "number" ? v : parseInt(v, 10);
          return Number.isFinite(n) ? n : null;
        };
        const compIdInt = toInt(CompID);
        // Only set to true if there are actual child branches
        const hasChildBranches = Array.isArray(branches) && branches.some((b) => {
          const parentComId = toInt(b?.ParentComID ?? b?.parentComID);
          const branchCompId = toInt(b?.CompID ?? b?.compID);
          return parentComId !== null
            && compIdInt !== null
            && parentComId === compIdInt
            && branchCompId !== compIdInt;
        });
        setIsParentBranch(hasChildBranches);
      } catch (err) {
        setIsParentBranch(false);
      }
    };
    checkParentBranch();
  }, [CompID]);

  // Fetch branch assignments when item is loaded and company is parent
  useEffect(() => {
    if (itemId && isParentBranch && !initialLoading) {
      fetchBranchAssignments();
    }
  }, [itemId, isParentBranch, initialLoading, fetchBranchAssignments]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      await Promise.all([
        fetchSettings(),
        fetchCompCurrency(),
        fetchAllergens(),
        fetchProducts(),
        fetchAllCategories(),
        fetchUnits(),
      ]);
    }, 500);
    return () => clearTimeout(handler);
  }, [fetchSettings, fetchCompCurrency, fetchAllergens, fetchProducts, fetchAllCategories, fetchUnits]);

  useEffect(() => {
    if (!hasFetchedDetailsRef.current && settings.s_VAT !== undefined) {
      hasFetchedDetailsRef.current = true;
      fetchItemDetails();
    }
  }, [settings.s_VAT]);

  // Fallback: fetch item details after a timeout if it hasn't been fetched yet
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!hasFetchedDetailsRef.current) {
        hasFetchedDetailsRef.current = true;
        fetchItemDetails();
      }
    }, 3000); // 3 second fallback

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (allAllergens.length > 0 && selectors.selectedAllergens.some((a) => a.id === null)) {
      setSelectors((prev) => {
        // First, map allergens with null IDs to found allergens
        const mappedAllergens = prev.selectedAllergens.map((allergen) => {
          if (allergen.id === null) {
            const foundAllergen = allAllergens.find(
              (a) => a.allergen_Name.toLowerCase() === allergen.allergen_Name.toLowerCase()
            );
            return foundAllergen || allergen;
          }
          return allergen;
        });

        // Remove duplicates based on allergen_Name (case-insensitive)
        const uniqueAllergens = [];
        const seenNames = new Set();
        for (const allergen of mappedAllergens) {
          const nameKey = allergen.allergen_Name?.toLowerCase() || '';
          const idKey = allergen.id?.toString() || '';
          const uniqueKey = idKey || nameKey;

          if (!seenNames.has(uniqueKey)) {
            seenNames.add(uniqueKey);
            uniqueAllergens.push(allergen);
          }
        }

        return {
          ...prev,
          selectedAllergens: uniqueAllergens,
        };
      });
    }
  }, [allAllergens]);

  useEffect(() => {
    if (reportingCategory?.rootCat_ID || reportingCategory?.rC_ID) {
      const reportCatId = reportingCategory.rootCat_ID || reportingCategory.rC_ID;
      setVariants((prevVariants) => {
        const needsUpdate = prevVariants.some(
          (variant) => String(variant.reportCat_ID ?? "") !== String(reportCatId ?? "")
        );
        if (!needsUpdate) return prevVariants;
        return prevVariants.map((variant) => ({
          ...variant,
          reportCat_ID: reportCatId,
        }));
      });
    }
  }, [reportingCategory?.rootCat_ID, reportingCategory?.rC_ID]);

  // Load reporting category from allCategories when item has reportCat_ID but category not found in selected categories
  // On UPDATE page: Only load what's saved in DB, don't auto-set to first category
  useEffect(() => {
    const reportCatId =
      formState.reportCat_ID ||
      reportingCategory?.rootCat_ID ||
      reportingCategory?.rC_ID;

    const hasName = !!(reportingCategory?.rootCat_Name || reportingCategory?.rC_Name);

    if (reportCatId && !hasName && allCategories.length > 0) {
      const reportCatIdNum = Number(reportCatId);
      const reportingCat = allCategories.find(
        (cat) =>
          cat &&
          (Number(cat.rootCat_ID) === reportCatIdNum ||
            Number(cat.rC_ID) === reportCatIdNum)
      );
      if (reportingCat) {
        setReportingCategory(reportingCat);
      }
    }
  }, [formState.reportCat_ID, allCategories, reportingCategory]);

  // Auto-enable/disable modifierGroupsEnabled based on selection
  useEffect(() => {
    const modifierGroupsLength = Array.isArray(selectors.selectedModifierGroups)
      ? selectors.selectedModifierGroups.length
      : 0;
    const hasModifierGroups = modifierGroupsLength > 0;

    setToggles((prev) => {
      if (prev.modifierGroupsEnabled !== hasModifierGroups) {
        return {
          ...prev,
          modifierGroupsEnabled: hasModifierGroups,
        };
      }
      return prev;
    });
  }, [selectors.selectedModifierGroups]);

  // Auto-enable/disable allergensEnabled based on selection
  useEffect(() => {
    const hasAllergens = selectors.selectedAllergens.length > 0;
    setToggles((prev) => {
      if (prev.allergensEnabled === hasAllergens) return prev;
      return {
        ...prev,
        allergensEnabled: hasAllergens,
      };
    });
  }, [selectors.selectedAllergens]);

  // Auto-enable/disable menuGroupsEnabled based on selection
  useEffect(() => {
    const hasMenuGroups = selectors.selectedMenuGroups.length > 0;
    setToggles((prev) => {
      if (prev.menuGroupsEnabled === hasMenuGroups) return prev;
      return {
        ...prev,
        menuGroupsEnabled: hasMenuGroups,
      };
    });
  }, [selectors.selectedMenuGroups]);

  // Filter units based on selected measurement type
  useEffect(() => {
    if (formState.menuItem_MeasurementType && units.length > 0) {
      const filtered = units.filter(
        (unit) => (unit.MeasurementTypeName || unit.measurementTypeName) === formState.menuItem_MeasurementType
      );
      setFilteredUnits(filtered);
      console.log("Filtered units for", formState.menuItem_MeasurementType, ":", filtered);
    } else {
      setFilteredUnits([]);
    }
  }, [formState.menuItem_MeasurementType, units]);

  // Normalize variant unit values on load (support symbol/id/name from API)
  useEffect(() => {
    if (!toggles.menuItem_HasVariant) return;
    const type = formState.menuItem_MeasurementType;
    if (type !== "Weight" && type !== "Volume") return;
    if (!Array.isArray(units) || units.length === 0) return;

    setVariants((prev) => {
      const prevList = Array.isArray(prev) ? prev : [];
      let changed = false;
      const next = prevList.map((v) => {
        const current = (v?.menuItem_DefaultSizeUnit ?? "").toString();
        if (current) {
          const normalized = normalizeUnitForSelect(current, type);
          if (normalized !== current) {
            changed = true;
            return { ...v, menuItem_DefaultSizeUnit: normalized };
          }
          return v;
        }

        const raw =
          v?.MenuItem_DefaultSizeUnit ??
          v?.defaultSizeUnit ??
          v?.DefaultSizeUnit ??
          "";
        const normalized = normalizeUnitForSelect(raw, type);
        if (normalized) {
          changed = true;
          return { ...v, menuItem_DefaultSizeUnit: normalized };
        }
        return v;
      });

      return changed ? next : prev;
    });
  }, [units, formState.menuItem_MeasurementType, toggles.menuItem_HasVariant]);

  // Calculate DefaultSizeInBaseUnit when measurement type, default size, or unit changes
  useEffect(() => {
    const setBaseUnitIfChanged = (nextValue) => {
      setFormState((prev) => {
        if (Number(prev.menuitem_DefaultSizeInBaseUnit) === Number(nextValue)) {
          return prev;
        }
        return {
          ...prev,
          menuitem_DefaultSizeInBaseUnit: nextValue,
        };
      });
    };

    if (formState.menuItem_MeasurementType === "Unit") {
      setBaseUnitIfChanged(0);
    } else if (
      formState.menuItem_MeasurementType &&
      (formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") &&
      formState.menuItem_DefaultSize &&
      formState.menuItem_DefaultSizeUnit &&
      units.length > 0
    ) {
      const selectedUnit = units.find(
        (unit) =>
          (unit.MeasureName || unit.measureName || unit.unitName || unit.name) === formState.menuItem_DefaultSizeUnit &&
          (unit.MeasurementTypeName || unit.measurementTypeName) === formState.menuItem_MeasurementType
      );

      if (selectedUnit) {
        const measurementValue = selectedUnit.Measurement || selectedUnit.measurement || selectedUnit.conversionValue || 1;
        const defaultSize = parseFloat(formState.menuItem_DefaultSize) || 0;
        setBaseUnitIfChanged(defaultSize * measurementValue);
      } else {
        setBaseUnitIfChanged(0);
      }
    } else {
      setBaseUnitIfChanged(0);
    }
  }, [
    formState.menuItem_MeasurementType,
    formState.menuItem_DefaultSize,
    formState.menuItem_DefaultSizeUnit,
    units,
  ]);

  // Re-normalize variant units when units list loads (fixes race condition)
  useEffect(() => {
    if (!hasFetchedDetailsRef.current || units.length === 0 || !toggles.menuItem_HasVariant) return;
    
    setVariants((prevVariants) => {
      let changed = false;
      const next = prevVariants.map((variant) => {
        if (!variant.menuItem_DefaultSizeUnit) return variant;
        
        const rawUnitValue = String(variant.menuItem_DefaultSizeUnit).trim();
        const rawUnitLower = rawUnitValue.toLowerCase();
        
        // Find unit by name, symbol, or id (case-insensitive)
        const matchedUnit = units.find((u) => {
          const unitName = (u.MeasureName || u.measureName || u.unitName || u.name || "").toLowerCase();
          const unitSymbol = (u.symbol || u.Symbol || "").toLowerCase();
          const unitId = u.MeasureID || u.measureID || u.unitID || u.id;
          
          return (
            rawUnitLower === unitName ||
            rawUnitLower === unitSymbol ||
            rawUnitValue === String(unitId)
          );
        });
        
        if (matchedUnit) {
          const normalizedUnitName = matchedUnit.MeasureName || matchedUnit.measureName || matchedUnit.unitName || matchedUnit.name;
          if (variant.menuItem_DefaultSizeUnit !== normalizedUnitName) {
            changed = true;
            return {
              ...variant,
              menuItem_DefaultSizeUnit: normalizedUnitName,
            };
          }
        }
        
        return variant;
      });

      return changed ? next : prevVariants;
    });
  }, [units, toggles.menuItem_HasVariant]);

  // When shared measurement type changes, clear per-variant unit/base (no inherit)
  // BUT: Don't clear during initial data load (when changing from "" to actual value)
  useEffect(() => {
    const nextType = formState.menuItem_MeasurementType;
    const prevType = prevMeasurementTypeRef.current;
    
    // Always update the ref to track the current value
    prevMeasurementTypeRef.current = nextType;
    
    // Don't clear if:
    // 1. We haven't fetched details yet
    // 2. Previous type was null (initial state)
    // 3. Previous type was empty string (initial form state before data load)
    // 4. Types are the same
    if (!hasFetchedDetailsRef.current) return;
    if (prevType === null || prevType === "") return;
    if (prevType === nextType) return;
    
    if (!toggles.menuItem_HasVariant) return;
    setVariants((prev) =>
      (prev || []).map((v) => ({
        ...v,
        menuItem_MeasurementType: nextType || "",
        menuItem_DefaultSizeUnit: "",
        menuitem_DefaultSizeInBaseUnit: 0,
        ...(nextType === "Unit" ? { menuItem_DefaultSize: "" } : {}),
      }))
    );
  }, [formState.menuItem_MeasurementType, toggles.menuItem_HasVariant]);

  // Set CSS custom property for theme color
  useEffect(() => {
    document.documentElement.style.setProperty('--theme-color', themeColor);
  }, [appTheme]);

  useEffect(() => {
    if (
      !hasUserEditedTax &&
      !toggles.isTaxExempt &&
      settings.isTaxEnabled &&
      settings.s_VAT &&
      (!formState.menuItem_TaxPercentage || formState.menuItem_TaxPercentage === "")
    ) {
      setFormState((prev) => ({
        ...prev,
        menuItem_TaxPercentage: settings.s_VAT.toString(),
      }));
    } else if (toggles.isTaxExempt) {
      setFormState((prev) => ({
        ...prev,
        menuItem_TaxPercentage: "",
      }));
    }
  }, [toggles.isTaxExempt, settings.s_VAT, settings.isTaxEnabled, hasUserEditedTax, formState.menuItem_TaxPercentage]);



  const handleInputChange = (field) => (e) => {
    let value = e.target.value;

    // Clear "0" when user starts typing in numeric fields
    const numericFields = [
      "menuItem_TaxPercentage",
      "current_Quantity",
      "reorder_Quantity",
      "reorder_Level"
    ];

    if (numericFields.includes(field) && value === "0") {
      value = "";
    }

    if (field === "menuItem_TaxPercentage") {
      if (toggles.isTaxExempt) {
        setFormState((prev) => ({ ...prev, menuItem_TaxPercentage: "" }));
        return;
      }
      if (value === "" || /^\d*\.?\d*$/.test(value)) {
        setHasUserEditedTax(true);
        setFormState((prev) => ({ ...prev, menuItem_TaxPercentage: value }));
      } else {
        showErrorToast("Tax Percentage must be a valid number (e.g., 20)");
      }
      return;
    }
    setFormState((prev) => ({ ...prev, [field]: value }));
    if (field === "menuItem_Name") {
      setErrors((prev) => ({
        ...prev,
        menuItem_Name: value.trim() ? "" : "Item Name is required",
      }));
      // Also update Kitchen Display Name when Item Name changes
      setFormState((prev) => ({ ...prev, menuItem_KitchenDisplayName: value }));
    }
    if (field === "menuItem_PreparationTime" && value && !/^\d+$/.test(value)) {
      showErrorToast("Preparation Time must be a positive number (e.g., 40)");
      return;
    }
    if (field === "menuItem_ServingSize" && value && !/^\d+$/.test(value)) {
      showErrorToast("Serving Size must be a positive number (e.g., 1)");
      return;
    }
    if (field === "menuItem_SalePrice" && value && !/^\d*\.?\d*$/.test(value)) {
      showErrorToast("Sale Price must be a valid number (e.g., 100)");
      return;
    }
  };

  const parseItemPrice = (value) => {
    if (value == null || String(value).trim() === "") return 0;
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? NaN : parsed;
  };

  // Helper function to display value or empty string if "0" or "0.00"
  const getDisplayValue = (value) => {
    if (!value || value === "0" || value === "0.00" || parseFloat(value) === 0) {
      return "";
    }
    return value;
  };

  const normalizeUnitForSelect = (rawUnit, measurementType) => {
    if (rawUnit === null || rawUnit === undefined) return "";
    const unitStr = String(rawUnit).trim();
    if (!unitStr) return "";
    if (!measurementType) return unitStr;
    if (!Array.isArray(units) || units.length === 0) return unitStr;

    const getTypeName = (u) => u.MeasurementTypeName || u.measurementTypeName || "";
    const getName = (u) => u.MeasureName || u.measureName || u.unitName || u.name || "";
    const getSymbol = (u) =>
      u.symbol ||
      u.Symbol ||
      u.MeasureSymbol ||
      u.measureSymbol ||
      u.Abbreviation ||
      u.abbreviation ||
      u.ShortName ||
      u.shortName ||
      "";
    const getId = (u) => u.MeasureID || u.measureID || u.unitID || u.id;

    const unitLower = unitStr.toLowerCase();
    
    // Try exact name match first (case-insensitive)
    const byName = units.find(
      (u) => getTypeName(u) === measurementType && getName(u).toLowerCase() === unitLower
    );
    if (byName) return getName(byName);

    // Try symbol match (case-insensitive)
    const bySymbol = units.find(
      (u) => getTypeName(u) === measurementType && getSymbol(u).toLowerCase() === unitLower
    );
    if (bySymbol) return getName(bySymbol);

    // Try ID match (numeric)
    const asNum = Number(unitStr);
    if (!Number.isNaN(asNum)) {
      const byId = units.find((u) => getTypeName(u) === measurementType && Number(getId(u)) === asNum);
      if (byId) return getName(byId);
    }

    return unitStr;
  };

  const handleProductQuantityChange = (productId, value) => {
    if (value && !/^\d+$/.test(value)) {
      showErrorToast("Item Quantity must be a positive number");
      return;
    }
    if (parseInt(value) <= 0) {
      showErrorToast("Item Quantity must be greater than 0");
      return;
    }
    setSelectors((prev) => ({
      ...prev,
      selectedProducts: prev.selectedProducts?.map((product) =>
        product.menuItem_ID === productId
          ? { ...product, availableQuantity: value }
          : product
      ),
    }));
  };

  const handleToggle = (field) => () => {
    setToggles((prev) => {
      const newToggles = { ...prev, [field]: !prev[field] };
      if (field === "menuItem_Publish" && newToggles.menuItem_Publish) {
        newToggles.is_OutOfStock = false;
        newToggles.is_ShowInKiosk = true;
        newToggles.isSellOnTill = true;
        newToggles.isActiveMobileApp = true;
      } else if (field === "is_OutOfStock" && newToggles.is_OutOfStock) {
        newToggles.menuItem_Publish = false;
        newToggles.is_ShowInKiosk = false;
        newToggles.isSellOnTill = false;
        newToggles.isActiveMobileApp = false;
      } else if (field === "is_OutOfStock" && !newToggles.is_OutOfStock) {
        newToggles.menuItem_Publish = true;
      } else if (
        ["is_ShowInKiosk", "isSellOnTill", "isActiveMobileApp"].includes(field)
      ) {
        const { is_ShowInKiosk, isSellOnTill, isActiveMobileApp } = {
          ...prev,
          [field]: !prev[field],
        };
        newToggles.menuItem_Publish =
          is_ShowInKiosk || isSellOnTill || isActiveMobileApp;
      } else if (field === "menuItem_IsSellingProduct" && !newToggles.menuItem_IsSellingProduct) {
        // When "Is Selling Product" is disabled, disable "Show in POS" and "Show in Online"
        newToggles.isSellOnTill = false;
        newToggles.isActiveMobileApp = false;
        newToggles.menuGroupsEnabled = false;
        newToggles.allergensEnabled = false;
        newToggles.modifierGroupsEnabled = false;
        newToggles.menuItem_HasVariant = false;

        setSelectors((prevSelectors) => ({
          ...prevSelectors,
          selectedParentCategory: [],
          selectedMenuGroups: [],
          selectedModifierGroups: [],
          selectedAllergens: [],
        }));
        setVariants([
          {
            ...Modifier,
            menuItem_SellingMethodBoth: false,
            reportCat_ID: (reportingCategory.rootCat_ID || reportingCategory.rC_ID) || "",
            menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
            menuItem_DefaultSize: "",
            menuItem_DefaultSizeUnit: "",
            menuitem_DefaultSizeInBaseUnit: 0,
          },
        ]);
      } else if (field === "menuItem_IsSellingProduct" && newToggles.menuItem_IsSellingProduct) {
        // When "Is Selling Product" is enabled, set Is Modifier to false
        newToggles.menuItem_IsModifier = false;
      } else if (field === "productsEnabled" && !newToggles.productsEnabled) {
        setSelectors((prev) => ({ ...prev, selectedProducts: [] }));
      } else if (field === "isTaxExempt") {
        setFormState((prev) => ({
          ...prev,
          menuItem_TaxPercentage: newToggles.isTaxExempt
            ? ""
            : prev.menuItem_TaxPercentage ||
            (settings.isTaxEnabled && settings.s_VAT
              ? settings.s_VAT.toString()
              : ""),
        }));
      }
      if (
        field === "productsEnabled" &&
        newToggles.productsEnabled &&
        formState.menuItem_Type === "Combo"
      ) {
        fetchProducts();
      }
      return newToggles;
    });
  };

  const handleVariantChange = (index, field, value) => {
    let updatedVariants = variants.map((variant, i) =>
      i === index
        ? { ...variant, [field]: value, reportCat_ID: (reportingCategory.rootCat_ID || reportingCategory.rC_ID) || "" }
        : variant
    );

    const calculateDefaultSizeInBaseUnit = (measurementType, defaultSize, defaultSizeUnit) => {
      if (measurementType !== "Weight" && measurementType !== "Volume") return 0;
      if (!defaultSize || !defaultSizeUnit || units.length === 0) return 0;
      const selectedUnit = units.find(
        (unit) =>
          (unit.MeasureName || unit.measureName || unit.unitName || unit.name) === defaultSizeUnit &&
          (unit.MeasurementTypeName || unit.measurementTypeName) === measurementType
      );
      if (!selectedUnit) return 0;
      const measurementValue =
        selectedUnit.Measurement || selectedUnit.measurement || selectedUnit.conversionValue || 1;
      const size = parseFloat(defaultSize) || 0;
      return size * measurementValue;
    };

    if (field === "menuItem_DefaultSize" || field === "menuItem_DefaultSizeUnit") {
      const v = updatedVariants[index] || {};
      const base = calculateDefaultSizeInBaseUnit(
        formState.menuItem_MeasurementType,
        v.menuItem_DefaultSize,
        v.menuItem_DefaultSizeUnit
      );
      updatedVariants[index] = {
        ...v,
        menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
        menuitem_DefaultSizeInBaseUnit: base,
      };
    }

    if (field === "menuItem_IsDefaultVariant" && value === true) {
      updatedVariants = updatedVariants.map((variant, i) => ({
        ...variant,
        menuItem_IsDefaultVariant: i === index ? true : false,
      }));

      const defaultVariant = updatedVariants[index];

      setFormState((prev) => ({
        ...prev,
        menuItem_SalePrice: defaultVariant.menuItem_SalePrice || "0.00",
        menuItem_DeliveryPrice: defaultVariant.menuItem_DeliveryPrice || "0.00",
        menuItem_TakeAwayPrice: defaultVariant.menuItem_TakeAwayPrice || "0.00",
        menuItem_TaxPercentage: defaultVariant.menuItem_TaxPercentage || "0.00",
        menuItem_CostPrice: defaultVariant.menuItem_CostPrice || "0.00",
      }));
    }

    setVariants(updatedVariants);
    if (field === "menuItem_Name" && value && index === variants.length - 1) {
      setVariants([
        ...updatedVariants,
        {
          ...Modifier,
          menuItem_SellingMethodBoth: false,
          reportCat_ID: (reportingCategory.rootCat_ID || reportingCategory.rC_ID) || "",
          // No inherit for per-variant size/unit
          menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
          menuItem_DefaultSize: "",
          menuItem_DefaultSizeUnit: "",
          menuitem_DefaultSizeInBaseUnit: 0,
        },
      ]);
    }
  };

  const updateVariantTrackStock = async (variantId, isTrackStock) => {
    const id = typeof variantId === "number" ? variantId : parseInt(variantId, 10);
    if (!id || id <= 0) return;
    if (!isParentBranch) return;

    const foundVariant = variants.find((v) => (v?.menuItem_ID ?? v?.MenuItem_ID) === id);
    const prevChecked = !!(foundVariant?.menuItem_IsTrackStock ?? foundVariant?.MenuItem_IsTrackStock);

    // optimistic UI
    setVariants((prev) =>
      prev.map((v) => {
        const vid = v?.menuItem_ID ?? v?.MenuItem_ID;
        if (vid !== id) return v;
        return { ...v, menuItem_IsTrackStock: !!isTrackStock };
      })
    );

    setSavingVariantTrackStock((prev) => ({ ...prev, [id]: true }));
    try {
      const itemRes = await axiosInstance.get(APIs.GET_ITEM_BY_ID, {
        params: { CompID, MenuItem_ID: id },
      });
      const currentItemData = itemRes?.data?.data || itemRes?.data?.Data || itemRes?.data || {};
      const g = (c, p, def) => (currentItemData == null ? def : (currentItemData[c] ?? currentItemData[p] ?? def));

      // Preserve all attributes not changed by this action; only set MenuItem_IsTrackStock
      const payload = {
        menuItem_ID: id,
        localizeID: "en",
        compID: CompID,
        current_Quantity: parseFloat(g("current_Quantity", "Current_Quantity", 0)) || 0,
        reorder_Quantity: parseFloat(g("reorder_Quantity", "Reorder_Quantity", 0)) || 0,
        reorder_Level: parseFloat(g("reorder_Level", "Reorder_Level", 0)) || 0,
        availableQuantity: g("availableQuantity", "AvailableQuantity", null) ?? null,
        orderQuantityLimit: parseInt(g("orderQuantityLimit", "OrderQuantityLimit", 0), 10) || 0,
        MenuItem_IsBuyingProduct: !!g("menuItem_IsBuyingProduct", "MenuItem_IsBuyingProduct", false),
        MenuItem_IsStockingProduct: !!g("menuItem_IsStockingProduct", "MenuItem_IsStockingProduct", false),
        MenuItem_SourceType: g("menuItem_SourceType", "MenuItem_SourceType", "Purchase") || "Purchase",
        MenuItem_HasRecipe: !!g("menuItem_HasRecipe", "MenuItem_HasRecipe", false),
        MenuItem_RecipeId: parseInt(g("menuItem_RecipeId", "MenuItem_RecipeId", 0), 10) || 0,
        MenuItem_RecipeType: g("menuItem_RecipeType", "MenuItem_RecipeType", "Made to order") || "Made to order",
        MenuItem_IsTrackBatch: !!g("menuItem_IsTrackBatch", "MenuItem_IsTrackBatch", false),
        MenuItem_IsTrackStock: !!isTrackStock,
        MenuItem_SellingMethodBoth: !!g("menuItem_SellingMethodBoth", "MenuItem_SellingMethodBoth", false),
        MenuItem_IsSellingProduct: !!g("menuItem_IsSellingProduct", "MenuItem_IsSellingProduct", false),
        MenuItem_CostPrice: g("menuItem_CostPrice", "MenuItem_CostPrice", null) ?? null,
        MenuItem_PurchaseContainerType: g("menuItem_PurchaseContainerType", "MenuItem_PurchaseContainerType", "Individual") || "Individual",
        MenuItem_PurchaseContainerQty: parseInt(g("menuItem_PurchaseContainerQty", "MenuItem_PurchaseContainerQty", 1), 10) || 1,
      };

      const updateRes = await axiosInstance.put(APIs.PUT_UPDATE_ITEM_INVENTORY, payload);
      if (updateRes?.data?.status) {
        showSuccessToast("Variant Track Stock updated.");
      } else {
        throw new Error(updateRes?.data?.message || "Failed to update Track Stock.");
      }
    } catch (err) {
      // revert on failure
      setVariants((prev) =>
        prev.map((v) => {
          const vid = v?.menuItem_ID ?? v?.MenuItem_ID;
          if (vid !== id) return v;
          return { ...v, menuItem_IsTrackStock: !!prevChecked };
        })
      );
      showErrorToast(err?.response?.data?.message || err?.message || "Failed to update Track Stock.");
    } finally {
      setSavingVariantTrackStock((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleRemoveVariant = (index) => {
    const remaining = variants.filter((_, i) => i !== index);
    if (remaining.length === 0) {
      setVariants([{ ...Modifier, menuItem_SellingMethodBoth: false, reportCat_ID: (reportingCategory.rootCat_ID || reportingCategory.rC_ID) || "" }]);
      return;
    }
    const last = remaining[remaining.length - 1];
    if (last && (last.menuItem_Name || "").trim()) {
      setVariants([...remaining, { ...Modifier, menuItem_SellingMethodBoth: false, reportCat_ID: (reportingCategory.rootCat_ID || reportingCategory.rC_ID) || "" }]);
    } else {
      setVariants(remaining);
    }
  };

  const handleDragStart = (e, index) => {
    dragItem.current = index;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("application/json", JSON.stringify(index));
    e.currentTarget.style.opacity = "0.5";
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();
    dragOverItem.current = index;
    e.currentTarget.style.backgroundColor = "#e9ecef";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const draggedIndex = JSON.parse(e.dataTransfer.getData("application/json"));
    const overIndex = dragOverItem.current;
    if (
      draggedIndex === overIndex ||
      draggedIndex === undefined ||
      overIndex === undefined
    ) {
      dragItem.current = null;
      dragOverItem.current = null;
      return;
    }
    const newVariants = [...variants];
    const draggedVariant = newVariants[draggedIndex];
    newVariants.splice(draggedIndex, 1);
    newVariants.splice(overIndex, 0, draggedVariant);
    setVariants(newVariants);
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const handleDragEnd = (e) => {
    e.currentTarget.style.opacity = "1";
    document.querySelectorAll("tr").forEach((tr) => {
      tr.style.backgroundColor = "";
    });
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const disablePastDates = (current) => {
    return !current.isSameOrAfter(moment().startOf("day"));
  };

  const handleASTimeChange = (time) => {
    const formattedTime = moment(time).format("HH:mm");
    setFormState((prev) => ({ ...prev, menuItem_ASTime: formattedTime }));
  };

  const handleAETimeChange = (time) => {
    const formattedTime = moment(time).format("HH:mm");
    setFormState((prev) => ({ ...prev, menuItem_AETime: formattedTime }));
  };

  const handleProductTypeSelect = (type) => {
    setFormState((prev) => ({ ...prev, menuItem_RootType: type }));
    setModals((prev) => ({ ...prev, isModalOpen: false }));
  };

  const handleReportingCategorySubmit = (categoryData) => {
    setReportingCategory(categoryData || {});
    setModals((prev) => ({ ...prev, showReportingCategoryModal: false }));
  };

  const removeProduct = (productId) => {
    setSelectors((prev) => ({
      ...prev,
      selectedProducts: prev.selectedProducts.filter(
        (p) => p.menuItem_ID !== productId
      ),
    }));
  };

  const handleSelectorSubmit = (key) => (selectedItems) => {
    if (key === "selectedProducts") {
      const updatedItems = selectedItems?.map((item) => ({
        ...item,
        availableQuantity: item.availableQuantity || "1",
      }));
      setSelectors((prev) => ({ ...prev, [key]: updatedItems }));
    } else {
      setSelectors((prev) => ({
        ...prev,
        [key]: Array.isArray(selectedItems) ? selectedItems : [],
      }));
    }

    setModals((prev) => ({
      ...prev,
      [`show${key.charAt(0).toUpperCase() + key.slice(1)}Modal`]: false,
    }));
  };

  const handleUpdate = async (e, shouldExit = false) => {
   
    // Prevent update if this is a branch viewing a parent company product
    if (isBranchMode && isParentCompanyProduct) {
      showErrorToast("This product belongs to the parent company. Please use the branch edit page.");
      navigate(`/items/branchEditItem/${itemId}`);
      return false;
    }
    if (e) {
      e.preventDefault();
    }
    if (!formState.menuItem_Name.trim()) {
      setErrors((prev) => ({ ...prev, menuItem_Name: "Name is required" }));
      showErrorToast("Name is required.");
      return false;
    }
    if (toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant) {
      const validVariants = variants.filter((v) => v.menuItem_Name.trim());
      if (validVariants.length === 0) {
        showErrorToast(
          "At least one variant is required when variants are enabled."
        );
        return false;
      }
      const defaultVariant = validVariants.find(
        (v) => v.menuItem_IsDefaultVariant
      );
      if (!defaultVariant) {
        showErrorToast("At least one variant must be marked as default.");
        return false;
      }
      for (const variant of validVariants) {
        const variantSalePrice = parseItemPrice(variant.menuItem_SalePrice);
        if (Number.isNaN(variantSalePrice) || variantSalePrice < 0) {
          showErrorToast("Variant Sale Price must be zero or a positive number.");
          return false;
        }
        variant.menuItem_SalePrice = String(variantSalePrice);
        // Cost price can be 0, auto-set to 0 if empty
        if (!variant.menuItem_CostPrice || variant.menuItem_CostPrice === "" || isNaN(parseFloat(variant.menuItem_CostPrice))) {
          variant.menuItem_CostPrice = "0";
        } else if (parseFloat(variant.menuItem_CostPrice) < 0) {
          showErrorToast("Variant Cost Price cannot be negative.");
          return false;
        }
      }

      // Variant measurement validation (Weight/Volume only)
      const needsSizeUnit =
        formState.menuItem_MeasurementType === "Weight" ||
        formState.menuItem_MeasurementType === "Volume";
      if (needsSizeUnit) {
        for (let i = 0; i < validVariants.length; i++) {
          const v = validVariants[i];
          const size = parseFloat(v.menuItem_DefaultSize);
          if (!v.menuItem_DefaultSizeUnit || isNaN(size) || size <= 0) {
            showErrorToast(
              `Default size and unit are required for variant: ${v.menuItem_Name || `#${i + 1}`}`
            );
            return false;
          }
        }
      }
    } else {
      // Skip sale price validation for non-selling products; allow 0 price
      const salePrice = parseItemPrice(formState.menuItem_SalePrice);
      if (toggles.menuItem_IsSellingProduct && (Number.isNaN(salePrice) || salePrice < 0)) {
        setErrors((prev) => ({
          ...prev,
          menuItem_SalePrice: "Sale Price cannot be negative",
        }));
        showErrorToast("Sale Price cannot be negative.");
        return false;
      }
      // Cost price can be 0, auto-set to 0 if empty
      if (!formState.menuItem_CostPrice || formState.menuItem_CostPrice === "" || isNaN(parseFloat(formState.menuItem_CostPrice))) {
        setFormState((prev) => ({ ...prev, menuItem_CostPrice: "0" }));
      } else if (parseFloat(formState.menuItem_CostPrice) < 0) {
        showErrorToast("Cost Price cannot be negative.");
        return false;
      }
    }
    if (formState.menuItem_Type !== "Combo" && selectors.selectedParentCategory.length === 0 && toggles.menuItem_IsSellingProduct) {
      showErrorToast("At least one category must be selected.");
      return false;
    }
    // Skip reporting category validation for combo items
    if (formState.menuItem_Type !== "Combo" && !reportingCategory?.rootCat_ID && !reportingCategory?.rC_ID) {
      showErrorToast("Reporting Category is required.");
      return false;
    }
    if (
      formState.menuItem_Type === "Combo" &&
      selectors.selectedProducts.length === 0
    ) {
      showErrorToast("At least one product must be selected for a combo item.");
      return false;
    }
    if (
      formState.menuItem_Type === "Combo" &&
      selectors.selectedProducts.some(
        (product) =>
          !product.availableQuantity || !/^\d+$/.test(product.availableQuantity)
      )
    ) {
      showErrorToast("All selected products must have a valid quantity.");
      return;
    }
    if (
      toggles.allergensEnabled &&
      selectors.selectedAllergens.length === 0
    ) {
      showErrorToast("At least one allergen must be selected when allergens are enabled.");
      return false;
    }

    // Fetch current item data to preserve existing values for fields not being edited
    let currentItemData;
    try {
      const itemResponse = await axiosInstance.get(APIs.GET_ITEM_BY_ID, {
        params: { CompID, MenuItem_ID: itemId },
      });
      currentItemData = itemResponse.data.data || itemResponse.data;
    } catch (err) {
      showErrorToast("Failed to fetch current item data");
      return false;
    }

    setLoading(true);
    let uploadedImageUrl = toRelativeMediaPath(imageState.menuItem_Image);
    try {
      if (imageState.imageFile) {
        uploadedImageUrl = await uploadCompanyMediaFile(
          axiosInstance,
          APIs,
          CompID,
          imageState.imageFile,
          "Product"
        );
      }
    } catch (err) {
      showErrorToast(err.message || "Failed to upload image");
      setLoading(false);
      return false;
    }
    try {
      const isSellingProduct = !!toggles.menuItem_IsSellingProduct;
      const reportingCategoryId =
        reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
          ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
          : 0;
      const categoriesForPayload = isSellingProduct
        ? selectors.selectedParentCategory
        : reportingCategoryId
          ? [reportingCategory]
          : [];
      const menuItemTypeForPayload =
        formState.menuItem_Type === "Combo" || isComboItem
          ? "Combo"
          : toggles.menuItem_IsModifier && !isSellingProduct
            ? "Modifier"
            : "Product";
      const mainName = (formState.menuItem_Name || "").trim();
      const buildVariantTitle = (variantName) => {
        const vName = (variantName || "").trim();
        return vName ? `${mainName} (${vName})` : mainName;
      };

      // For variant products: parent (group item entry) gets the default variant's prices
      const variantsForPayload =
        toggles.menuItem_HasVariant
          ? (variants || []).filter(
              (v) => v.menuItem_Name && v.menuItem_Name.trim().length > 0
            )
          : [];
      const defaultVariantForParent =
        variantsForPayload.find((v) => v.menuItem_IsDefaultVariant) ||
        variantsForPayload[0];
      const defaultVariant = defaultVariantForParent;
      const parentSalePrice =
        toggles.menuItem_HasVariant && defaultVariantForParent
          ? parseItemPrice(defaultVariantForParent.menuItem_SalePrice)
          : parseItemPrice(formState.menuItem_SalePrice);
      const rawDelivery =
        toggles.menuItem_HasVariant && defaultVariantForParent
          ? parseFloat(defaultVariantForParent.menuItem_DeliveryPrice) || 0
          : parseFloat(formState.menuItem_DeliveryPrice) || 0;
      const rawTakeAway =
        toggles.menuItem_HasVariant && defaultVariantForParent
          ? parseFloat(defaultVariantForParent.menuItem_TakeAwayPrice) || 0
          : parseFloat(formState.menuItem_TakeAwayPrice) || 0;
      const parentDeliveryPrice =
        toggles.menuItem_HasVariant && rawDelivery <= 0
          ? parentSalePrice
          : rawDelivery;
      const parentTakeAwayPrice =
        toggles.menuItem_HasVariant && rawTakeAway <= 0
          ? parentSalePrice
          : rawTakeAway;
      const parentCostPrice =
        toggles.menuItem_HasVariant && defaultVariantForParent
          ? defaultVariantForParent.menuItem_CostPrice != null &&
            String(defaultVariantForParent.menuItem_CostPrice).trim() !== "" &&
            !isNaN(parseFloat(defaultVariantForParent.menuItem_CostPrice))
            ? parseFloat(defaultVariantForParent.menuItem_CostPrice)
            : 0
          : parseFloat(formState.menuItem_CostPrice) || 0;
      const parentTaxPercentage =
        toggles.menuItem_HasVariant && defaultVariantForParent
          ? defaultVariantForParent.menuItem_TaxPercentage != null &&
            String(defaultVariantForParent.menuItem_TaxPercentage).trim() !== "" &&
            !isNaN(parseFloat(defaultVariantForParent.menuItem_TaxPercentage))
            ? parseFloat(defaultVariantForParent.menuItem_TaxPercentage)
            : 0
          : toggles.isTaxExempt
            ? 0
            : parseFloat(formState.menuItem_TaxPercentage) || 0;

      const itemOwnerCompID =
        parseInt(
          currentItemData?.compID ??
            currentItemData?.CompID ??
            CompID,
          10
        ) || CompID;
      const itemLocalizeID =
        currentItemData?.localizeID ||
        currentItemData?.LocalizeID ||
        formState.localizeID ||
        "en";

      const payload = {
        menuItem_ID: parseInt(itemId),
        localizeID: itemLocalizeID,
        compID: itemOwnerCompID,
        menuItem_Name: formState.menuItem_Name,
        menuItem_DefaultVariantTitle:
          menuItemTypeForPayload === "Combo"
            ? (currentItemData?.menuItem_DefaultVariantTitle ??
              currentItemData?.MenuItem_DefaultVariantTitle ??
              "")
            : mainName,
        menuItem_KitchenDisplayName: formState.menuItem_KitchenDisplayName,
        menuItem_Detail: formState.menuItem_Detail,
        menuItem_SalePrice: parentSalePrice,
        menuItem_Image: uploadedImageUrl || "",
        menuItem_Orderby: parseInt(formState.menuItem_Orderby) || 0,
        menuItem_Publish: toggles.menuItem_Publish,
        menuItem_DataCreated: new Date().toISOString(),
        menuItem_ExpiryDate: expiryDate ? expiryDate.toISOString() : null,
        menuItem_DateModified: new Date().toISOString(),
        menuItem_DeliveryPrice: parentDeliveryPrice,
        menuItem_TakeAwayPrice: parentTakeAwayPrice,
        menuItem_CostPrice: parentCostPrice,
        menuItem_TaxPercentage: parentTaxPercentage,
        menuItem_SKU: toggles.skuEnabled ? formState.menuItem_SKU : "",
        menuItem_RootType: formState.menuItem_RootType,
        menuItem_SEOTitle: formState.menuItem_SEOTitle,
        menuItem_SEODescription: formState.menuItem_SEODescription,
        menuItem_Permalink: formState.menuItem_Permalink,
        isActiveMobileApp: toggles.isActiveMobileApp,
        is_OutOfStock: toggles.is_OutOfStock,
        isSellOnTill: toggles.isSellOnTill,
        is_ShowInKiosk: toggles.is_ShowInKiosk,
        hasAllergen:
          isSellingProduct &&
          toggles.allergensEnabled &&
          selectors.selectedAllergens.length > 0,
        // Set MenuItem_HaveModifier true whenever at least one modifier group is selected
        menuItem_HaveModifier:
          isSellingProduct &&
          Array.isArray(selectors.selectedModifierGroups) &&
          selectors.selectedModifierGroups.length > 0,
        categories: categoriesForPayload,
        modifierGroups:
          isSellingProduct && toggles.modifierGroupsEnabled
            ? selectors.selectedModifierGroups
            : [],
        menuGroups: isSellingProduct ? selectors.selectedMenuGroups : [],
        allergens:
          isSellingProduct &&
          toggles.allergensEnabled &&
          selectors.selectedAllergens.length > 0
            ? selectors.selectedAllergens.map((a) => a.allergen_Name).join(", ")
            : "",
        menuItem_PreparationTime: formState.menuItem_PreparationTime.trim(),
        menuItem_ServingSize: formState.menuItem_ServingSize.trim(),
        menuItem_ASTime: formState.menuItem_ASTime || "",
        menuItem_AETime: formState.menuItem_AETime || "",
        menuItem_Rating: parseInt(formState.menuItem_Rating) || 0,
        menuItem_Homefeatured: toggles.menuItem_Homefeatured,
        menuItem_featured: toggles.menuItem_featured,
        menuItem_IsModifier: isSellingProduct ? false : toggles.menuItem_IsModifier,
        menuItem_ModifierType: toggles.menuItem_IsModifier 
          ? formState.menuItem_ModifierType || "0"
          : "0",
        menuItem_IsFavorite: toggles.menuItem_IsFavorite,
        menuItem_BarCode: formState.menuItem_BarCode || "",
        menuItem_Type: menuItemTypeForPayload,
        menuItem_ColorCode: formState.menuItem_ColorCode || "",
        retail_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.retail_Markup) || 0,
        delivery_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.delivery_Markup) || 0,
        online_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.online_Markup) || 0,
        current_Quantity: currentItemData?.current_Quantity ?? 0,
        reorder_Quantity: currentItemData?.reorder_Quantity ?? 0,
        reorder_Level: currentItemData?.reorder_Level ?? 0,
        availableQuantity: currentItemData?.availableQuantity ?? null,
        orderQuantityLimit: currentItemData?.orderQuantityLimit ?? 0,
        brand_ID: parseInt(formState.brand_ID) || 0,
        ingredientID: parseInt(formState.ingredientID) || 0,
        parentMenuItemID: parseInt(formState.parentMenuItemID) || 0,
        itsMasterProductID: parseInt(formState.itsMasterProductID) || 0,
        reportCat_ID: reportingCategoryId,
        stadardUnit: toggles.menuItem_HasVariant
          ? 0
          : parseInt(formState.stadardUnit) || 0,
        unitSize: toggles.menuItem_HasVariant
          ? 0
          : parseInt(formState.unitSize) || 0,
        mP_UnitOfSale: formState.mP_UnitOfSale || "",
        mP_VolumnOfSale: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.mP_VolumnOfSale) || 0,
        menuItem_HasVariant: !!toggles.menuItem_HasVariant,
        isArchieve: toggles.isArchieve,
        isAllowedtoSetPriceatThePointofSale:
          toggles.isAllowedtoSetPriceatThePointofSale,
        isTaxExempt: toggles.isTaxExempt,
        isPreventGainingLoyalty: toggles.isPreventGainingLoyalty,
        isHaveCustomerSpecificPricing: toggles.isHaveCustomerSpecificPricing,
        isProductisScannableOnly: toggles.isProductisScannableOnly,
        isMasterProduct: toggles.isMasterProduct,
        itHasAMasterProduct: toggles.itHasAMasterProduct,
        menuItem_IsDefaultModifier: toggles.menuItem_IsDefaultModifier,
        menuItem_DefaultModifierTitle:
          defaultVariant?.menuItem_DefaultModifierTitle || "",
        isShowNotificationExpDate: toggles.isShowNotificationExpDate,
        isShowSocialMediaLink: toggles.isShowSocialMediaLink,
        menuItem_SellingMethodBoth: toggles?.menuItem_SellingMethodBoth ?? false,
        MenuItem_IsSellingProduct:
          toggles.menuItem_IsSellingProduct || toggles.menuItem_HasVariant || false,
        menuItem_ImageAltText: formState.menuItem_ImageAltText || "",
        appMode: formState.appMode,
        // Preserve inventory and recipe-related fields
        MenuItem_IsTrackStock: currentItemData?.menuItem_IsTrackStock ?? false,
        MenuItem_IsTrackBatch: currentItemData?.menuItem_IsTrackBatch ?? false,
        MenuItem_SourceType: currentItemData?.menuItem_SourceType ?? "Purchase",
        MenuItem_IsBuyingProduct: currentItemData?.menuItem_IsBuyingProduct ?? false,
        MenuItem_IsStockingProduct: currentItemData?.menuItem_IsStockingProduct ?? false,
        MenuItem_PurchaseContainerType: currentItemData?.menuItem_PurchaseContainerType ?? "Individual",
        MenuItem_PurchaseContainerQty: currentItemData?.menuItem_PurchaseContainerQty ?? 1,
        MenuItem_HasRecipe: currentItemData?.menuItem_HasRecipe ?? false,
        MenuItem_RecipeId: currentItemData?.menuItem_RecipeId ?? 0,
        MenuItem_RecipeType: currentItemData?.menuItem_RecipeType ?? currentItemData?.MenuItem_RecipeType ?? "Made to order",
        menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
        menuItem_DefaultSize: formState.menuItem_DefaultSize ? parseFloat(formState.menuItem_DefaultSize) : 1,
        menuItem_DefaultSizeUnit: formState.menuItem_DefaultSizeUnit || "",
        menuItem_ContainerType: formState.menuItem_ContainerType || "",
        Menuitem_DefaultSizeInBaseUnit: formState.menuitem_DefaultSizeInBaseUnit || 0,
        Products:
          formState.menuItem_Type === "Combo"
            ? selectors.selectedProducts
            : toggles.menuItem_HasVariant
              ? variants
                .filter((v) => v.menuItem_Name && v.menuItem_Name.trim().length > 0)
                .map((v) => ({
                  ...v,
                  menuItem_ID: parseInt(v.menuItem_ID ?? v.MenuItem_ID, 10) || 0,
                  localizeID:
                    v.localizeID ||
                    v.LocalizeID ||
                    itemLocalizeID ||
                    "en",
                  compID: itemOwnerCompID,
                  isActiveMobileApp: toggles.isActiveMobileApp,
                  menuItem_Publish: toggles.menuItem_Publish,
                  menuItem_DefaultVariantTitle: buildVariantTitle(v.menuItem_Name),
                  menuItem_SalePrice: parseItemPrice(v.menuItem_SalePrice),
                  menuItem_DeliveryPrice: parseItemPrice(v.menuItem_DeliveryPrice),
                  menuItem_TakeAwayPrice: parseItemPrice(v.menuItem_TakeAwayPrice),
                  menuItem_CostPrice: v.menuItem_CostPrice && v.menuItem_CostPrice !== ""
                    ? parseFloat(v.menuItem_CostPrice) || 0
                    : 0,
                  menuItem_TaxPercentage: v.menuItem_TaxPercentage != null && String(v.menuItem_TaxPercentage).trim() !== "" && !isNaN(parseFloat(v.menuItem_TaxPercentage))
                    ? parseFloat(v.menuItem_TaxPercentage)
                    : 0,
                  menuItem_IsDefaultVariant: !!v.menuItem_IsDefaultVariant,
                  menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
                  menuItem_DefaultSize: v.menuItem_DefaultSize && v.menuItem_DefaultSize !== ""
                    ? parseFloat(v.menuItem_DefaultSize) || 0
                    : 0,
                  menuItem_DefaultSizeUnit: v.menuItem_DefaultSizeUnit || "",
                  Menuitem_DefaultSizeInBaseUnit: (v.menuitem_DefaultSizeInBaseUnit ?? v.Menuitem_DefaultSizeInBaseUnit) ?? 0,
                  reportCat_ID: (reportingCategory?.rootCat_ID || reportingCategory?.rC_ID)
                    ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
                    : 0,
                }))
              : [],
        BranchCompIDs: isParentBranch
          ? Array.from(
              new Set(
                (selectedBranches || [])
                  .map((b) => {
                    if (typeof b === "number") return parseInt(b, 10);
                    const branchId = b?.CompID ?? b?.compID ?? b?.branchCompID ?? b?.BranchCompID;
                    return branchId ? parseInt(branchId, 10) : null;
                  })
                  .filter((id) => id !== null && !isNaN(id) && id > 0)
              )
            )
          : undefined,
      };
      const response = await axiosInstance.put(APIs.PUT_UPDATE_ITEM, payload);
      if (response.data.status) {
        showSuccessToast("Item updated successfully");

        // Reload from server so variant prices reflect what was actually persisted
        try {
          await fetchItemDetails();
        } catch (_) {
          captureBaselineSnapshot();
        } 
        const warnings =
          response.data?.data?.branchAssignmentWarnings ||
          response.data?.data?.BranchAssignmentWarnings ||
          [];
        if (Array.isArray(warnings) && warnings.length > 0) {
          const warningText = warnings
            .map((w) => {
              const branchId = w.branchCompID ?? w.BranchCompID ?? 0;
              const branchName = getBranchDisplayNameById(branchId);
              const msg = w.message ?? w.Message ?? "";
              return `${branchName || `Branch ${branchId}`}: ${msg}`;
            })
            .join("\n");
          await swal({
            title: "Branch assignment warnings",
            text: warningText,
            icon: "warning",
          });
        }
        if (shouldExit) {
          navigate("/items/manageItems");
        }
        return true;
      } else {
        showErrorToast(response.data.message || "Failed to update item");
        return false;
      }
    } catch (error) {
      showErrorToast(error.response?.data?.message || "Failed to update item");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Handle tab change from ItemTabBar
  const handleTabChange = async (action, tab) => {
    if (action === "save") {
      const success = await handleUpdate(null, false);
      return success;
    } else if (action === "discard") {
      // Reset to initial state
      if (initialFormState) setFormState(JSON.parse(JSON.stringify(initialFormState)));
      if (initialToggles) setToggles(JSON.parse(JSON.stringify(initialToggles)));
      if (initialSelectors) setSelectors(JSON.parse(JSON.stringify(initialSelectors)));
      if (initialReportingCategory) setReportingCategory(JSON.parse(JSON.stringify(initialReportingCategory)));
      if (initialVariants.length > 0) setVariants(JSON.parse(JSON.stringify(initialVariants)));
      if (initialImageState) setImageState(JSON.parse(JSON.stringify(initialImageState)));
      if (initialExpiryDate) setExpiryDate(new Date(initialExpiryDate));
      setHasUnsavedChanges(false);
      return true;
    }
    return true;
  };

  const renderBreadcrumb = () => (
    <div className="d-flex align-items-center mb-3">
      <div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">Home</a>
          </li>
          <li className="breadcrumb-item">
            <Link to="/items/manageItems">Manage Items</Link>
          </li>
          <li className="breadcrumb-item active">Update Item</li>
        </ol>
        <h1 className="page-header mb-0" style={{ fontSize: "1.35rem" }}>
          {formState.menuItem_Type === "Combo"
            ? "Update Combo Item"
            : "Update Item"}
        </h1>
      </div>
      <div className="ms-auto">
        {/* Buttons moved to tab layout */}
      </div>
    </div>
  );



  const renderFormFields = () => {
    // Disable all inputs if this is a branch viewing a parent company product
    const isFormDisabled = isBranchMode && isParentCompanyProduct;
    
    return (
      <div className="row g-3">
      <div className="col-md-6">
        <FormInput
          label={
            formState.menuItem_Type === "Combo" ? "Combo Name *" : "Item Name *"
          }
          value={formState.menuItem_Name}
          onchange={handleInputChange("menuItem_Name")}
          type="text"
          placeHolder="Name"
          name="menuItem_Name"
          required
          disabled={isFormDisabled}
          error={errors.menuItem_Name}
        />
        <FormInput
          label={
            formState.menuItem_Type === "Combo"
              ? "Combo Kitchen Name"
              : "Kitchen Name"
          }
          value={formState.menuItem_KitchenDisplayName}
          onchange={handleInputChange("menuItem_KitchenDisplayName")}
          type="text"
          placeHolder="Kitchen Name"
          name="menuItem_KitchenDisplayName"
        />
        <div className="mb-4">
          <label className="form-label fw-medium">
            <b>
              {formState.menuItem_Type === "Combo"
                ? "Combo Description"
                : "Item Description"}
            </b>
          </label>
          <textarea
            className={`form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`}
            rows={6}
            placeholder="Description (max 500 characters)"
            value={formState.menuItem_Detail}
            onChange={handleInputChange("menuItem_Detail")}
            style={{
              borderRadius: "10px",
              border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
              background: isDarkMode ? "#2d3436" : "#F9F9F9",
              color: isDarkMode ? "#ffffff" : "#000000",
              transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            }}
          />
        </div>
        {formState.menuItem_Type !== "Combo" && toggles.menuItem_IsSellingProduct && (
          <div className="mb-4">
            <ToggleSwitch
              isChecked={toggles.menuItem_HasVariant}
              onToggle={handleToggle("menuItem_HasVariant")}
              label="Is Product have multiple variants"
              name="menuItem_HasVariant"
              themeColor={themeColor}
            />
          </div>
        )}
        {!toggles.menuItem_HasVariant && (
          <div
            className="card p-3 mb-4"
            style={{
              backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
              border: isDarkMode ? '1px solid #404040' : '1px solid #dee2e6',
              color: isDarkMode ? '#ffffff' : '#000000',
            }}
          >
            <h5 className="card-title mb-3">Pricing</h5>
            <div className="row g-3">
              <div className="col-6">
                <FormInput
                  label={`Cost Price (${compCurrency})`}
                  value={getDisplayValue(formState.menuItem_CostPrice)}
                  type="number"
                  placeHolder="0"
                  name="menuItem_CostPrice"
                  readOnly
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Tax (%)"
                  value={getDisplayValue(formState.menuItem_TaxPercentage)}
                  onchange={handleInputChange("menuItem_TaxPercentage")}
                  type="text"
                  placeHolder="0"
                  name="menuItem_TaxPercentage"
                  disabled={toggles.isTaxExempt}
                  title={ 
                    formState.menuItem_TaxPercentage !== "" &&
                      settings.s_VAT !== undefined &&
                      settings.s_VAT !== null &&
                      settings.s_VAT !== "" &&
                      formState.menuItem_TaxPercentage === String(settings.s_VAT)
                      ? "Default tax rate from settings - you can edit this value"
                      : "Enter tax percentage"
                  }
                />
                {formState.menuItem_TaxPercentage !== "" &&
                  settings.s_VAT !== undefined &&
                  settings.s_VAT !== null &&
                  settings.s_VAT !== "" &&
                  formState.menuItem_TaxPercentage === String(settings.s_VAT) ? (
                  <small className="text-muted">
                    <i className="fa fa-info-circle me-1"></i>
                    Default from settings - you can edit this value
                  </small>
                ) : null}
              </div>
              <div className="col-6">
                <FormInput
                  label={`Sale Price (${compCurrency}) *`}
                  value={getDisplayValue(formState.menuItem_SalePrice)}
                  onchange={handleInputChange("menuItem_SalePrice")}
                  type="number"
                  placeHolder="0"
                  name="menuItem_SalePrice"
                  required
                  error={errors.menuItem_SalePrice}
                />
              </div>
            </div>
            <h5 className="card-title mt-3">Additional Pricing</h5>
            <div className="row g-3 mt-2">
              <div className="col-6">
                <FormInput
                  label={`Takeaway Price (${compCurrency})`}
                  value={getDisplayValue(formState.menuItem_TakeAwayPrice)}
                  onchange={handleInputChange("menuItem_TakeAwayPrice")}
                  type="number"
                  placeHolder="0"
                  name="menuItem_TakeAwayPrice"
                />
              </div>
              <div className="col-6">
                <FormInput
                  label={`Delivery Price (${compCurrency})`}
                  value={getDisplayValue(formState.menuItem_DeliveryPrice)}
                  onchange={handleInputChange("menuItem_DeliveryPrice")}
                  type="number"
                  placeHolder="0"
                  name="menuItem_DeliveryPrice"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="col-md-6">
        <div className="row mb-2">
          <div className="col-md-12">
            <FormInput
              label="Product Type"
              value={formState.menuItem_RootType}
              onchange={handleInputChange("menuItem_RootType")}
              type="text"
              placeHolder="Select Product Type"
              name="menuItem_RootType"
              icon="fa fa-caret-down"
              iconOnClick={() =>
                setModals((prev) => ({ ...prev, isModalOpen: true }))
              }
              readOnly
            />
          </div>
          <div className="col-md-12">
            <FormInput
              label="Color Code"
              value={formState.menuItem_ColorCode}
              onchange={handleInputChange("menuItem_ColorCode")}
              type="color"
              name="menuItem_ColorCode"
            />
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-6">
            <FormInput
              label="Preparation Time"
              value={formState.menuItem_PreparationTime}
              onchange={handleInputChange("menuItem_PreparationTime")}
              type="text"
              placeHolder="Preparation Time (e.g., 40)"
              name="menuItem_PreparationTime"
            />
          </div>
          <div className="col-6">
            <FormInput
              label="Serving Size"
              value={formState.menuItem_ServingSize}
              onchange={handleInputChange("menuItem_ServingSize")}
              type="text"
              placeHolder="Serving Size (e.g., 1)"
              name="menuItem_ServingSize"
            />
          </div>
        </div>
        {!toggles.menuItem_HasVariant && (
          <div className="col-12 mb-3">
            <div
              className="card p-3 mb-4"
              style={{
                backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                border: isDarkMode ? '1px solid #404040' : '1px solid #dee2e6',
                color: isDarkMode ? '#ffffff' : '#000000',
              }}
            >
              <h5 className="card-title mb-3">Inventory</h5>
              <div className="row g-3">
                <div className="col-6">
                  <FormInput
                    label="Current Quantity"
                    value={getDisplayValue(formState.current_Quantity)}
                    onchange={handleInputChange("current_Quantity")}
                    type="number"
                    placeHolder="0"
                    name="current_Quantity"
                  />
                </div>
                <div className="col-6">
                  <FormInput
                    label="Reorder Quantity"
                    value={getDisplayValue(formState.reorder_Quantity)}
                    onchange={handleInputChange("reorder_Quantity")}
                    type="number"
                    placeHolder="0"
                    name="reorder_Quantity"
                  />
                </div>
                <div className="col-6">
                  <FormInput
                    label="Reorder Level"
                    value={getDisplayValue(formState.reorder_Level)}
                    onchange={handleInputChange("reorder_Level")}
                    type="number"
                    placeHolder="0"
                    name="reorder_Level"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {toggles.menuItem_IsSellingProduct && !isComboItem && toggles.menuItem_HasVariant && (
        <div className="row">
          <div className="col-12 mt-4">
            <div
              className="card p-3 mb-4"
              style={{
                backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                border: isDarkMode ? '1px solid #404040' : '1px solid #dee2e6',
                color: isDarkMode ? '#ffffff' : '#000000',
              }}
            >
              <h5 className="card-title mb-3">Variants</h5>
              <table className="table table-responsive">
                <thead style={{
                  backgroundColor: isDarkMode ? "#404040" : "#d9d9d9",
                  color: isDarkMode ? "#ffffff" : "#000000"
                }}>
                  <tr>
                    <th>Variant</th>
                    <th>Kitchen Name</th>
                    <th>Cost Price ({compCurrency})</th>
                    <th>Tax %</th>
                    <th>Sale Price ({compCurrency})</th>
                    <th>Delivery Price ({compCurrency})</th>
                    <th>Takeaway Price ({compCurrency})</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(variants || []).map((variant, index) => (
                    <tr
                      key={index}
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragEnter={(e) => handleDragEnter(e, index)}
                      onDragLeave={handleDragLeave}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      onDragEnd={handleDragEnd}
                    >
                      <td className="align-middle">
                        <FormInput
                          type="text"
                          value={variant.menuItem_Name || ""}
                          placeHolder="Enter Variant Name"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_Name",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="text"
                          value={variant.menuItem_KitchenDisplayName || ""}
                          placeHolder="Enter Kitchen Name"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_KitchenDisplayName",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="number"
                          value={variant.menuItem_CostPrice || ""}
                          placeHolder="0.00"
                          step="0.01"
                          readOnly={true}
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_CostPrice",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="number"
                          value={variant.menuItem_TaxPercentage || ""}
                          placeHolder="0.00"
                          step="0.01"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_TaxPercentage",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="number"
                          value={variant.menuItem_SalePrice || ""}
                          placeHolder="0.00"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          step="0.01"
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_SalePrice",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="number"
                          value={variant.menuItem_DeliveryPrice || ""}
                          placeHolder="0.00"
                          step="0.01"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_DeliveryPrice",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <FormInput
                          type="number"
                          value={variant.menuItem_TakeAwayPrice || ""}
                          placeHolder="0.00"
                          step="0.01"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onchange={(e) =>
                            handleVariantChange(
                              index,
                              "menuItem_TakeAwayPrice",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="align-middle">
                        <div className="d-flex align-items-center m-2 me-3">
                          <ToggleSwitch
                            isChecked={variant.menuItem_IsDefaultVariant}
                            label="Default"
                            onToggle={() =>
                              handleVariantChange(
                                index,
                                "menuItem_IsDefaultVariant",
                                !variant.menuItem_IsDefaultVariant
                              )
                            }
                            themeColor={themeColor}
                          />
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex align-items-center m-1">
                          <i
                            className="fa fa-trash text-danger m-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemoveVariant(index)}
                          ></i>
                          <i
                            className="fa fa-bars m-3"
                            style={{ cursor: "grab" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
    );
  };

  // Basic Information Panel
  const renderBasicInfoPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-info-circle me-2"></i>
        Basic Information
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <div className="row g-3">
          <div className="col-md-6">
            <FormInput
              label={isComboItem ? "Combo Name *" : "Item Name *"}
              value={formState.menuItem_Name}
              onchange={handleInputChange("menuItem_Name")}
              type="text"
              placeHolder="Name"
              name="menuItem_Name"
              required
              error={errors.menuItem_Name}
            />

            {/* Hidden Kitchen Name field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label={isComboItem ? "Combo Kitchen Name " : "Kitchen Name "}
                value={formState.menuItem_KitchenDisplayName}
                onchange={handleInputChange("menuItem_KitchenDisplayName")}
                type="text"
                placeHolder="Kitchen Name"
                name="menuItem_KitchenDisplayName"
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-medium">
                <b>{isComboItem ? "Combo Description" : "Item Description"}</b>
              </label>
              <textarea
                className={`form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`}
                rows={6}
                placeholder="Description (max 500 characters)"
                value={formState.menuItem_Detail}
                onChange={handleInputChange("menuItem_Detail")}
                style={{
                  borderRadius: "10px",
                  border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                  background: isDarkMode ? "#2d3436" : "#F9F9F9",
                  color: isDarkMode ? "#ffffff" : "#000000",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                }}
              />
            </div>


          </div>

          <div className="col-md-6">
            {/* Hidden Product Type field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label="Product Type"
                value={formState.menuItem_RootType}
                onchange={handleInputChange("menuItem_RootType")}
                type="text"
                placeHolder="Select Product Type"
                name="menuItem_RootType"
                icon="fa fa-caret-down"
                iconOnClick={() => setModals((prev) => ({ ...prev, isModalOpen: true }))}
              />
            </div>

            {/* Hidden Color Code field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label="Color Code"
                value={formState.menuItem_ColorCode}
                onchange={handleInputChange("menuItem_ColorCode")}
                type="color"
                name="menuItem_ColorCode"
              />
            </div>

            {/* Image Upload Section */}
            <div className="mb-3">
              <div
                className="card p-3"
                style={{
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  border: `1px solid ${themeColor}20`,
                  color: isDarkMode ? '#ffffff' : '#000000',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '10px'
                }}
              >
                <div className="text-center">
                  <ImageUploadWithGallery
                    compID={CompID}
                    mediaCategory="Product"
                    imageUrl={imageState.menuItem_Image}
                    imageFile={imageState.imageFile}
                    setImage={(url, file) =>
                      setImageState({ menuItem_Image: url, imageFile: file })
                    }
                  />
                </div>
              </div>
            </div>
          </div>


        </div>

        <div className="row g-3">
          {!isComboItem && (
            <>
             

              {/* Product Settings Switches - Moved from Product Settings Panel */}
              <div className="row g-3 mb-4">
                <div className="col-md-6 col-lg-3">
                  <div className="d-flex align-items-center p-3 rounded"
                    style={{
                      backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                      border: `1px solid ${themeColor}20`,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <ToggleSwitch
                      isChecked={toggles.menuItem_Publish}
                      onToggle={handleToggle("menuItem_Publish")}
                      label="Active"
                      name="menuItem_Publish"
                      themeColor={themeColor}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="d-flex align-items-center p-3 rounded"
                    style={{
                      backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                      border: `1px solid ${themeColor}20`,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <ToggleSwitch
                      isChecked={toggles.menuItem_IsSellingProduct || false}
                      onToggle={handleToggle("menuItem_IsSellingProduct")}
                      label="Is Selling Product"
                      name="menuItem_IsSellingProduct"
                      themeColor={themeColor}
                    />
                  </div>
                </div>
                {!toggles.menuItem_IsSellingProduct && (
                  <div className="col-md-6 col-lg-3">
                    <div
                      className="d-flex align-items-center p-3 rounded"
                      style={{
                        backgroundColor: isDarkMode ? "#3c4043" : "#f8f9fa",
                        border: `1px solid ${themeColor}20`,
                        transition: "all 0.3s ease",
                      }}
                    >
                      <ToggleSwitch
                        isChecked={toggles.menuItem_IsModifier || false}
                        onToggle={handleToggle("menuItem_IsModifier")}
                        label="Is Modifier"
                        name="menuItem_IsModifier"
                        themeColor={themeColor}
                      />
                    </div>
                  </div>
                )}
                {toggles.menuItem_IsSellingProduct && (
                  <>
                    <div className="col-md-6 col-lg-3">
                      <div className="d-flex align-items-center p-3 rounded"
                        style={{
                          backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                          border: `1px solid ${themeColor}20`,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ToggleSwitch
                          isChecked={toggles.isSellOnTill}
                          onToggle={handleToggle("isSellOnTill")}
                          label="Show in POS"
                          name="isSellOnTill"
                          themeColor={themeColor}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="d-flex align-items-center p-3 rounded"
                        style={{
                          backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                          border: `1px solid ${themeColor}20`,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ToggleSwitch
                          isChecked={toggles.isActiveMobileApp}
                          onToggle={handleToggle("isActiveMobileApp")}
                          label="Show in Online"
                          name="isActiveMobileApp"
                          themeColor={themeColor}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="mb-3">
                {toggles.menuItem_IsSellingProduct && formState.menuItem_Type !== "Combo" && (
                  <ToggleSwitch
                    isChecked={toggles.menuItem_HasVariant}
                    onToggle={handleToggle("menuItem_HasVariant")}
                    label="Is Product have multiple variants"
                    name="menuItem_HasVariant"
                    themeColor={themeColor}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </PanelBody>
    </Panel>
  );

  // Pricing Panel
  const renderPricingPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-dollar-sign me-2"></i>
        Pricing Information
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        {!toggles.menuItem_HasVariant && (
          <div className="row g-3">
            <div className="col-md-6">

              <div className="row g-3">
                <div className="col-12">
                  <FormInput
                    label={`Sale Price (${compCurrency}) *`}
                    value={getDisplayValue(formState.menuItem_SalePrice)}
                    onchange={handleInputChange("menuItem_SalePrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_SalePrice"
                    required
                    error={errors.menuItem_SalePrice}
                  />
                </div>
                <div className="col-8">
                  <FormInput
                    label={`Cost Price (${compCurrency})`}
                    value={getDisplayValue(formState.menuItem_CostPrice)}
                    onchange={handleInputChange("menuItem_CostPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_CostPrice"
                  />
                </div>
                <div className="col-4">
                  <FormInput
                    label="Tax (%)"
                    value={getDisplayValue(formState.menuItem_TaxPercentage)}
                    onchange={handleInputChange("menuItem_TaxPercentage")}
                    type="text"
                    placeHolder="0"
                    name="menuItem_TaxPercentage"
                    disabled={toggles.isTaxExempt}
                    title={
                      formState.menuItem_TaxPercentage &&
                        settings.s_VAT &&
                        formState.menuItem_TaxPercentage ===
                        settings.s_VAT.toString()
                        ? "Default tax rate from settings - you can edit this value"
                        : "Enter tax percentage"
                    }
                  />
                </div>

              </div>
            </div>

            <div className="col-md-6">

              <div className="row g-3">
                <div className="col-6">
                  <FormInput
                    label={`Takeaway Price (${compCurrency})`}
                    value={getDisplayValue(formState.menuItem_TakeAwayPrice)}
                    onchange={handleInputChange("menuItem_TakeAwayPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_TakeAwayPrice"
                  />
                </div>
                <div className="col-6">
                  <FormInput
                    label={`Delivery Price (${compCurrency})`}
                    value={getDisplayValue(formState.menuItem_DeliveryPrice)}
                    onchange={handleInputChange("menuItem_DeliveryPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_DeliveryPrice"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </PanelBody>
    </Panel>
  );

  // Measurements Panel
  const renderMeasurementsPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-ruler-combined me-2"></i>
        Measurements
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <div className="row g-3">
            {/* Measured Section */}
            <div className="col-12">
              <label className="form-label fw-medium mb-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                Measured
              </label>
              <div className="d-flex gap-2 mb-3">
                {["Unit", "Volume", "Weight"].map((type) => (
                  <button
                    key={type}
                    type="button"
                    onClick={() => {
                      setFormState((prev) => ({
                        ...prev,
                        menuItem_MeasurementType: type,
                        menuItem_DefaultSizeUnit: "", // Reset unit when measurement type changes
                        menuItem_DefaultSize: type === "Unit" ? "" : prev.menuItem_DefaultSize, // Clear default size for Unit
                        menuItem_ContainerType: type === "Unit" ? "" : prev.menuItem_ContainerType, // Clear container for Unit
                      }));
                    }}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      border: `2px solid ${formState.menuItem_MeasurementType === type
                          ? themeColor
                          : isDarkMode ? '#404040' : '#dee2e6'
                        }`,
                      borderRadius: '8px',
                      backgroundColor:
                        formState.menuItem_MeasurementType === type
                          ? `${themeColor}20`
                          : isDarkMode ? '#2d3436' : '#ffffff',
                      color:
                        formState.menuItem_MeasurementType === type
                          ? themeColor
                          : isDarkMode ? '#ffffff' : '#000000',
                      fontWeight: formState.menuItem_MeasurementType === type ? '600' : '400',
                      transition: 'all 0.2s ease',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => {
                      if (formState.menuItem_MeasurementType !== type) {
                        e.target.style.borderColor = themeColor;
                        e.target.style.backgroundColor = `${themeColor}10`;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (formState.menuItem_MeasurementType !== type) {
                        e.target.style.borderColor = isDarkMode ? '#404040' : '#dee2e6';
                        e.target.style.backgroundColor = isDarkMode ? '#2d3436' : '#ffffff';
                      }
                    }}
                  >
                    {type === "Unit" ? "In units" : type === "Volume" ? "By volume" : "By weight"}
                  </button>
                ))}
              </div>
              {!toggles.menuItem_HasVariant && formState.menuItem_MeasurementType && formState.menuItem_MeasurementType !== "Unit" && (
                <p className="text-muted small mb-0" style={{ color: isDarkMode ? '#adb5bd' : '#6c757d' }}>
                  This means that 1 Unit of {formState.menuItem_Name || "this product"} = {formState.menuItem_DefaultSize || "1"} {formState.menuItem_DefaultSizeUnit || "unit"}
                </p>
              )}
             
            </div>

            {/* Sale Method Section - Only show for Weight and Volume (NOT for variants) and when Is Selling Product is true */}
            {!toggles.menuItem_HasVariant &&
              toggles.menuItem_IsSellingProduct &&
              (formState.menuItem_MeasurementType === "Weight" ||
                formState.menuItem_MeasurementType === "Volume") && (
              <div className="col-12 mt-3">
                <div className="d-flex align-items-center p-3 rounded"
                  style={{
                    backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                    border: `1px solid ${themeColor}20`,
                    transition: 'all 0.3s ease'
                  }}
                >
                  <ToggleSwitch
                    isChecked={toggles.menuItem_SellingMethodBoth || false}
                    onToggle={handleToggle("menuItem_SellingMethodBoth")}
                    label="Is Both Sale Method (By Weight/Volume & Price Based)"
                    name="menuItem_SellingMethodBoth"
                    themeColor={themeColor}
                  />
                </div>
              </div>
            )}

            {/* Default Size and Container Section - Single Row (Only show for Volume and Weight) */}
            {!toggles.menuItem_HasVariant && (formState.menuItem_MeasurementType === "Volume" || formState.menuItem_MeasurementType === "Weight") && (
              <div className="col-12">
                <div className="row g-3">
                  {/* Default Size Number */}
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                      Default Size
                    </label>
                    <FormInput
                      type="number"
                      value={formState.menuItem_DefaultSize || ""}
                      onchange={handleInputChange("menuItem_DefaultSize")}
                      placeHolder="1"
                      name="menuItem_DefaultSize"
                      step="0.01"
                    />
                  </div>
                  {/* Default Size Unit */}
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000', visibility: 'hidden' }}>
                      Unit
                    </label>
                    <select
                      className="form-control"
                      value={formState.menuItem_DefaultSizeUnit || ""}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          menuItem_DefaultSizeUnit: e.target.value,
                        }))
                      }
                      style={{
                        borderRadius: "8px",
                        border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                        background: isDarkMode ? "#2d3436" : "#F9F9F9",
                        color: isDarkMode ? "#ffffff" : "#000000",
                        padding: "8px 12px",
                      }}
                    >
                      <option value="">Select unit</option>
                      {filteredUnits.map((unit) => {
                        const unitId = unit.MeasureID || unit.measureID || unit.unitID || unit.id;
                        const unitName = unit.MeasureName || unit.measureName || unit.unitName || unit.name;
                        const unitSymbol = unit.symbol || unit.Symbol || unitName;
                        return (
                          <option key={unitId} value={unitName}>
                            {unitSymbol}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {/* Container */}
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                      Container
                    </label>
                    <select
                      className="form-control"
                      value={formState.menuItem_ContainerType || ""}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          menuItem_ContainerType: e.target.value,
                        }))
                      }
                      style={{
                        borderRadius: "8px",
                        border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                        background: isDarkMode ? "#2d3436" : "#F9F9F9",
                        color: isDarkMode ? "#ffffff" : "#000000",
                        padding: "8px 12px",
                      }}
                    >
                      <option value="">Select container</option>
                      {["Unit", "Packet", "Box", "Bottle", "Can", "Bag", "Carton", "Case"].map((container) => (
                        <option key={container} value={container}>
                          {container}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
        </div>
      </PanelBody>
    </Panel>
  );

  // Variants Panel
  const renderVariantsPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-layer-group me-2"></i>
        Product Variants
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        {toggles.menuItem_IsSellingProduct && !isComboItem && toggles.menuItem_HasVariant && (
          <>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{
                backgroundColor: isDarkMode ? "#404040" : "#f8f9fa",
                color: isDarkMode ? "#ffffff" : "#000000"
              }}>
                <tr>
                  <th>Variant</th>
              
                  {(formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") && (
                    <>
                      <th>Default Size</th>
                      <th>Unit</th>
                    </>
                  )}
                  <th>Cost Price ({compCurrency})</th>
                  <th>Tax %</th>
                  <th>Sale Price ({compCurrency})</th>
                  <th>Delivery Price ({compCurrency})</th>
                  <th>Takeaway Price ({compCurrency})</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {variants.map((variant, index) => (
                  <tr
                    key={index}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragEnter={(e) => handleDragEnter(e, index)}
                    onDragLeave={handleDragLeave}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    onDragEnd={handleDragEnd}
                    style={{
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      color: isDarkMode ? '#ffffff' : '#000000'
                    }}
                  >
                    <td className="align-middle">
                      <FormInput
                        type="text"
                        value={variant.menuItem_Name || ""}
                        placeHolder="Enter Variant Name"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_Name",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    
                    {(formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") && (
                      <>
                        <td className="align-middle">
                          <FormInput
                            type="number"
                            value={variant.menuItem_DefaultSize || ""}
                            placeHolder="1"
                            step="0.01"
                            draggable={false}
                            onDragStart={(e) => e.stopPropagation()}
                            onchange={(e) =>
                              handleVariantChange(
                                index,
                                "menuItem_DefaultSize",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td className="align-middle">
                          <select
                            className="form-control"
                            value={variant.menuItem_DefaultSizeUnit || ""}
                            onChange={(e) =>
                              handleVariantChange(
                                index,
                                "menuItem_DefaultSizeUnit",
                                e.target.value
                              )
                            }
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              borderRadius: "8px",
                              border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                              background: isDarkMode ? "#2d3436" : "#F9F9F9",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              padding: "8px 12px",
                            }}
                          >
                            <option value="">Select unit</option>
                            {filteredUnits.map((unit) => {
                              const unitId = unit.MeasureID || unit.measureID || unit.unitID || unit.id;
                              const unitName = unit.MeasureName || unit.measureName || unit.unitName || unit.name;
                              const unitSymbol = unit.symbol || unit.Symbol || unitName;
                              return (
                                <option key={unitId} value={unitName}>
                                  {unitSymbol}
                                </option>
                              );
                            })}
                          </select>
                        </td>
                      </>
                    )}
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_CostPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_CostPrice",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_TaxPercentage || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_TaxPercentage",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_SalePrice || ""}
                        placeHolder="0.00"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        step="0.01"
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_SalePrice",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_DeliveryPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_DeliveryPrice",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_TakeAwayPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_TakeAwayPrice",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <div className="d-flex align-items-center m-2 me-3">
                        <ToggleSwitch
                          isChecked={variant.menuItem_IsDefaultVariant}
                          label="Default"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onToggle={() =>
                            handleVariantChange(
                              index,
                              "menuItem_IsDefaultVariant",
                              !variant.menuItem_IsDefaultVariant
                            )
                          }
                          themeColor={themeColor}
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="d-flex align-items-center m-1">
                        <button
                          className="btn btn-sm btn-outline-danger me-2"
                          onClick={() => handleRemoveVariant(index)}
                          style={{
                            borderRadius: '6px',
                            padding: '4px 8px'
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                        <i
                          className="fa fa-bars"
                          style={{
                            cursor: "grab",
                            color: themeColor,
                            fontSize: '16px'
                          }}
                        ></i>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          </>
        )}
      </PanelBody>
    </Panel>
  );

  // Categories Panel
  const renderCategoriesPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-tags me-2"></i>
        Categories & Classification
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <CategorySelector
          selectedCategories={selectors.selectedParentCategory}
          setSelectedCategories={(updater) =>
            setSelectors((prev) => {
              const currentCats = prev.selectedParentCategory;
              const newCats =
                typeof updater === "function"
                  ? updater(currentCats)
                  : updater;
              return { ...prev, selectedParentCategory: newCats };
            })
          }
          showModal={modals.showParentCategoryModal}
          setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showParentCategoryModal: true })) : setModals((prev) => ({ ...prev, showParentCategoryModal: false }))}
          onModalSubmit={handleSelectorSubmit("selectedParentCategory")}
          setLoading={setLoading}
          excludeAddOnCategories={true}
        />

        {/* Reporting Category Display - Always show when categories are selected */}
        {selectors.selectedParentCategory.length > 0 && (
          <div className="mt-4">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                padding: "12px 16px",
                background: isDarkMode ? "#3d4447" : "#f8f9fa",
                borderRadius: "8px",
                border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{
                  fontSize: "14px",
                  color: isDarkMode ? "#ffffff" : "#6c757d",
                  fontWeight: "500"
                }}>
                  Reporting category for this item is:{" "}
                  <strong style={{
                    color: isDarkMode ? "#ffffff" : "#495057",
                    fontWeight: "600"
                  }}>
                    {reportingCategory?.rootCat_Name ||
                      reportingCategory?.rC_Name ||
                      ((formState.reportCat_ID || reportingCategory?.rootCat_ID || reportingCategory?.rC_ID)
                        ? "Loading..."
                        : "Not selected")}
                  </strong>
                </span>
              </div>
              <button
                onClick={() => setModals((prev) => ({ ...prev, showReportingCategoryModal: true }))}
                style={{
                  background: "transparent",
                  border: "none",
                  borderRadius: "6px",
                  padding: "6px 8px",
                  color: themeColor,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "32px",
                  height: "32px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${themeColor}20`;
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.transform = "scale(1)";
                }}
                title="Edit reporting category"
              >
                <i className="fa fa-edit" style={{ fontSize: "14px" }}></i>
              </button>
            </div>
          </div>
        )}
      </PanelBody>
    </Panel>
  );

  // Add-on Groups & Allergens Panel - Only for non-combo items
  const renderModifiersAllergensPanel = () => {
    if (isComboItem) return null;
    if (!toggles.menuItem_IsSellingProduct) return null;

    return (
      <Panel className="mb-3">
        <PanelHeader
          style={{
            backgroundColor: themeColor,
            color: 'white',
            border: 'none',
            borderRadius: '10px 10px 0 0',
            padding: '12px 20px',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          <i className="fas fa-list-ul me-2"></i>
          Add-on Groups & Allergens
        </PanelHeader>
        <PanelBody
          style={{
            padding: '16px 20px',
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            borderRadius: '0 0 10px 10px',
            border: `1px solid ${themeColor}20`
          }}
        >
          <div className="row g-3">
            <div className="col-md-6">
              <ModifierGroupsSelector
                selectedGroups={selectors.selectedModifierGroups}
                setSelectedGroups={(groups) =>
                  setSelectors((prev) => ({
                    ...prev,
                    selectedModifierGroups: Array.isArray(groups) ? groups : [],
                  }))
                }
                showModal={modals.showModifierModal}
                setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showModifierModal: true })) : setModals((prev) => ({ ...prev, showModifierModal: false }))}
                onModalSubmit={handleSelectorSubmit("selectedModifierGroups")}
                setLoading={setLoading}
              />
            </div>
            <div className="col-md-6">
              <AllergenSelector
                selectedAllergens={selectors.selectedAllergens}
                setSelectedAllergens={(allergens) =>
                  setSelectors((prev) => ({
                    ...prev,
                    selectedAllergens: allergens,
                  }))
                }
                showModal={modals.showAllergenModal}
                setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showAllergenModal: true })) : setModals((prev) => ({ ...prev, showAllergenModal: false }))}
                onModalSubmit={handleSelectorSubmit("selectedAllergens")}
                allergens={allAllergens}
                setLoading={setLoading}
              />
            </div>
          </div>
        </PanelBody>
      </Panel>
    );
  };

  // Combo Products Panel
  const renderComboProductsPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-layer-group me-2"></i>
        Combo Products
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <>
          {selectors.selectedProducts.length > 0 ? (
            <div className="mt-3">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
                {selectors.selectedProducts.map((product) => (
                  <div key={product.menuItem_ID} className="col">
                    <div
                      className="product-chip"
                      style={{
                        background: isDarkMode ? "#3d4447" : "#ffffff",
                        borderRadius: "12px",
                        padding: "16px 20px",
                        border: isDarkMode ? "2px solid rgba(255, 255, 255, 0.2)" : "2px solid #e9ecef",
                        transition: "all 0.2s ease",
                        cursor: "default",
                        position: "relative",
                        boxShadow: isDarkMode ? "0 2px 8px rgba(0, 0, 0, 0.3)" : "0 2px 8px rgba(0, 0, 0, 0.05)",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = "#007bff";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 123, 255, 0.15)";
                        e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = isDarkMode ? "rgba(255, 255, 255, 0.2)" : "#e9ecef";
                        e.currentTarget.style.boxShadow = isDarkMode ? "0 2px 8px rgba(0, 0, 0, 0.3)" : "0 2px 8px rgba(0, 0, 0, 0.05)";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              background: isDarkMode ? "#2d3436" : "#f8f9fa",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "12px",
                              border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #e9ecef",
                              overflow: "hidden",
                            }}
                          >
                            {product.menuItem_Image ? (
                              <img
                                src={product.menuItem_Image}
                                alt={product.menuItem_DefaultVariantTitle ?? product.MenuItem_DefaultVariantTitle ?? product.menuItem_Name ?? product.MenuItem_Name ?? ""}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                }}
                              />
                            ) : (
                              <i className="fa fa-box" style={{ fontSize: "14px", color: isDarkMode ? "#adb5bd" : "#6c757d" }}></i>
                            )}
                          </div>
                          <div>
                            <span style={{ fontSize: "15px", fontWeight: "500", color: isDarkMode ? "#ffffff" : "#495057" }}>
                              {product.menuItem_DefaultVariantTitle ?? product.MenuItem_DefaultVariantTitle ?? product.menuItem_Name ?? product.MenuItem_Name ?? ""}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <FormInput
                            type="text"
                            value={product.availableQuantity}
                            onchange={(e) => handleProductQuantityChange(product.menuItem_ID, e.target.value)}
                            placeHolder="Qty"
                            style={{
                              width: "60px",
                              fontSize: "12px",
                              padding: "4px 8px",
                              border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #e9ecef",
                              borderRadius: "4px",
                              textAlign: "center",
                              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                              color: isDarkMode ? "#ffffff" : "#000000",
                            }}
                          />
                          <button
                            onClick={() => removeProduct(product.menuItem_ID)}
                            style={{
                              background: "transparent",
                              border: "none",
                              borderRadius: "6px",
                              width: "28px",
                              height: "28px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              color: "#dc3545",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = isDarkMode ? "rgba(220, 53, 69, 0.2)" : "#f8d7da";
                              e.currentTarget.style.color = isDarkMode ? "#ff6b7a" : "#721c24";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.color = "#dc3545";
                            }}
                          >
                            <i className="fa fa-times" style={{ fontSize: "12px" }}></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-4">
                <button
                  onClick={() => setModals((prev) => ({ ...prev, showProductModal: true }))}
                  style={{
                    backgroundColor: themeColor,
                    background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                    border: `1px solid ${themeColor}`,
                    boxShadow: `0 4px 15px ${themeColor}40`,
                    borderRadius: "8px",
                    padding: "10px 20px",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = `0 6px 20px ${themeColor}60`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = `0 4px 15px ${themeColor}40`;
                  }}
                >
                  <i className="fa-solid fa-plus" style={{ fontSize: "12px" }}></i>
                  Choose Product
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center py-4">
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: "#f8f9fa",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                  border: "1px solid #e9ecef",
                }}
              >
                <i className="fa fa-box" style={{ fontSize: "24px", color: "#6c757d" }}></i>
              </div>
              <p style={{ color: "#6c757d", fontSize: "15px", marginBottom: "20px" }}>
                No products selected
              </p>
              <button
                onClick={() => setModals((prev) => ({ ...prev, showProductModal: true }))}
                style={{
                  backgroundColor: themeColor,
                  background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                  border: `1px solid ${themeColor}`,
                  boxShadow: `0 4px 15px ${themeColor}40`,
                  borderRadius: "8px",
                  padding: "10px 20px",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  margin: "0 auto",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = `0 6px 20px ${themeColor}60`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 4px 15px ${themeColor}40`;
                }}
              >
                <i className="fa-solid fa-plus" style={{ fontSize: "12px" }}></i>
                Choose Product
              </button>
            </div>
          )}
          <ProductMultiSelectionModal
            isEnabled={true}
            setIsEnabled={() => { }}
            selectedProducts={selectors.selectedProducts}
            setSelectedProducts={(products) =>
              setSelectors((prev) => ({
                ...prev,
                selectedProducts: products.map((p) => ({
                  ...p,
                  availableQuantity: p.availableQuantity || "1",
                })),
              }))
            }
            showModal={modals.showProductModal}
            setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showProductModal: true })) : setModals((prev) => ({ ...prev, showProductModal: false }))}
            onModalSubmit={handleSelectorSubmit("selectedProducts")}
            setLoading={setLoading}
            products={products}
            showButton={true}
          />
        </>
      </PanelBody>
    </Panel>
  );

  // SEO Section
  const renderSEO = () => (
    <div>
      <div className="row g-3">
        <div className="col-12">
          <FormInput
            label="Title"
            type="text"
            placeHolder="Enter Title"
            name="menuItem_SEOTitle"
            value={formState.menuItem_SEOTitle}
            onchange={handleInputChange("menuItem_SEOTitle")}
          />
        </div>
        <div className="col-12">
          <FormInput
            label="URL Slug"
            type="text"
            placeHolder="Enter URL Slug"
            name="menuItem_Permalink"
            value={formState.menuItem_Permalink}
            onchange={handleInputChange("menuItem_Permalink")}
          />
        </div>
        <div className="col-12">
          <FormInput
            label="Image Description"
            type="text"
            placeHolder="Enter Image Description"
            name="menuItem_ImageAltText"
            value={formState.menuItem_ImageAltText}
            onchange={handleInputChange("menuItem_ImageAltText")}
          />
        </div>
        <div className="col-12">
          <label className="form-label fw-medium">Meta Description</label>
          <textarea
            className="form-control"
            rows={3}
            placeholder="Enter Meta Description"
            value={formState.menuItem_SEODescription}
            onChange={handleInputChange("menuItem_SEODescription")}
            style={{
              border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
              background: isDarkMode ? "#2d3436" : "#F9F9F9",
              color: isDarkMode ? "#ffffff" : "#000000",
            }}
          />
        </div>
      </div>
    </div>
  );

  // Menu Groups & SEO Combined Panel
  const renderMenuGroupsSEOPanel = () => (
    <Panel className="mb-3">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-cog me-2"></i>
        Menus & SEO
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <div className="row g-3">
          {/* Menus - 6 columns when SEO visible, full width when SEO hidden */}
          <div className={toggles.menuItem_IsSellingProduct ? "col-md-6" : "col-12"}>
            <h6 className="mb-3" style={{ color: themeColor, fontWeight: '600' }}>
              <i className="fas fa-th-list me-2"></i>
              Menus
            </h6>
            <MenuGroupsSelector
              selectedGroups={selectors.selectedMenuGroups}
              setSelectedGroups={(groups) =>
                setSelectors((prev) => ({
                  ...prev,
                  selectedMenuGroups: Array.isArray(groups) ? groups : [],
                }))
              }
              showModal={modals.showMenuGroupModal}
              setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showMenuGroupModal: true })) : setModals((prev) => ({ ...prev, showMenuGroupModal: false }))}
              onModalSubmit={handleSelectorSubmit("selectedMenuGroups")}
              setLoading={setLoading}
            />
          </div>

          {/* SEO - 6 columns - Only show for selling products */}
          {toggles.menuItem_IsSellingProduct && (
            <div className="col-md-6">
              <h6 className="mb-3" style={{ color: themeColor, fontWeight: '600' }}>
                <i className="fas fa-search me-2"></i>
                Search Ranking Improvement
              </h6>
              {renderSEO()}
            </div>
          )}
        </div>
      </PanelBody>
    </Panel>
  );
 

  // Additional Options component
  const renderAdditionalOptions = () => (
    <Panel className="h-100">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '12px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-sliders-h me-2"></i>
        Additional Options
      </PanelHeader>
      <PanelBody
        style={{
          padding: '16px 20px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`,
          height: '100%'
        }}
      >
        {/* Barcode Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <FormInput
              label="Barcode"
              value={formState.menuItem_BarCode}
              onchange={handleInputChange("menuItem_BarCode")}
              type="text"
              placeHolder="Barcode"
              name="menuItem_BarCode"
            />
          </div>
        </div>

        {/* Preparation Time and Serving Size */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <FormInput
              label="Preparation Time"
              value={formState.menuItem_PreparationTime}
              onchange={handleInputChange("menuItem_PreparationTime")}
              type="text"
              placeHolder="Preparation Time (e.g., 40)"
              name="menuItem_PreparationTime"
            />
          </div>
          <div className="col-12">
            <FormInput
              label="Serving Size"
              value={formState.menuItem_ServingSize}
              onchange={handleInputChange("menuItem_ServingSize")}
              type="text"
              placeHolder="Serving Size (e.g., 1)"
              name="menuItem_ServingSize"
            />
          </div>
        </div>

        {/* SKU Enable Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center gap-3">
              <div className="flex-shrink-0">
                <ToggleSwitch
                  isChecked={toggles.skuEnabled}
                  onToggle={handleToggle("skuEnabled")}
                  label="SKU Enable"
                  name="skuEnabled"
                  themeColor={themeColor}
                />
              </div>
              {toggles.skuEnabled && (
                <div className="flex-grow-1">
                  <FormInput
                    placeHolder="SKU Code"
                    type="text"
                    value={formState.menuItem_SKU}
                    onchange={handleInputChange("menuItem_SKU")}
                    className="form-control"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Expiry Date Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center gap-3">
              <div className="flex-shrink-0">
                <ToggleSwitch
                  isChecked={toggles.expiryDateEnabled}
                  onToggle={handleToggle("expiryDateEnabled")}
                  label="Expiry Date"
                  name="expiryDateEnabled"
                  themeColor={themeColor}
                />
              </div>
              {toggles.expiryDateEnabled && (
                <div className="flex-grow-1">
                  <DebugMUIDatePicker
                    value={expiryDate}
                    onChange={(date) => setExpiryDate(date)}
                    placeholder="Select expiry date"
                    name="expiryDate"
                    clearable={true}
                    minDate={new Date()} // Disable past dates
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tax Exempt Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <ToggleSwitch
                isChecked={toggles.isTaxExempt}
                onToggle={handleToggle("isTaxExempt")}
                label="Tax Exempt"
                name="isTaxExempt"
                themeColor={themeColor}
              />
            </div>
          </div>
        </div>
      </PanelBody>
    </Panel>
  );

  // Additional Flags component - 6 columns
  const renderAdditionalFlags = () => (
    <div className="col-6">
      <Panel className="h-100">
        <PanelHeader
          style={{
            backgroundColor: themeColor,
            color: 'white',
            border: 'none',
            borderRadius: '10px 10px 0 0',
            padding: '12px 20px',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          <i className="fas fa-flag me-2"></i>
          Additional Flags
        </PanelHeader>
        <PanelBody
          style={{
            padding: '16px 20px',
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            borderRadius: '0 0 10px 10px',
            border: `1px solid ${themeColor}20`,
            height: '100%'
          }}
        >
          <div className="row row-cols-1 g-3">
            {[
              { label: "Tax Exempt", field: "isTaxExempt" },
              { label: "Prevent Loyalty Points", field: "isPreventGainingLoyalty" },
              { label: "Show Expiry Notification", field: "isShowNotificationExpDate" },
              { label: "Is Archived", field: "isArchieve" },
              { label: "Set Price at POS", field: "isAllowedtoSetPriceatThePointofSale" },
              { label: "Show Social Media Link", field: "isShowSocialMediaLink" },
            ].map(({ label, field }) => (
              <div key={field} className="col-12">
                <div
                  className="d-flex align-items-center p-3 rounded"
                  style={{
                    backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                    border: `1px solid ${themeColor}20`,
                    transition: 'all 0.3s ease'
                  }}
                >
                  <ToggleSwitch
                    isChecked={toggles[field]}
                    onToggle={handleToggle(field)}
                    label={label}
                    name={field}
                    themeColor={themeColor}
                  />
                </div>
              </div>
            ))}
          </div>
        </PanelBody>
      </Panel>
    </div>
  );

  // Other section component - 6 columns
  const renderOtherSection = () => (
    <div className="col-6">
      <Panel className="h-100">
        <PanelHeader
          style={{
            backgroundColor: themeColor,
            color: 'white',
            border: 'none',
            borderRadius: '10px 10px 0 0',
            padding: '12px 20px',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          <i className="fas fa-cog me-2"></i>
          Other Settings
        </PanelHeader>
        <PanelBody
          style={{
            padding: '16px 20px',
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            borderRadius: '0 0 10px 10px',
            border: `1px solid ${themeColor}20`,
            height: '100%'
          }}
        >
          <div className="row g-3" style={{ display: 'none' }}>
            {/* <div className="col-12">
              <label
                className="form-label fw-medium"
                style={{
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Available Start Time
              </label>
              <DateTime
                dateFormat={false}
                timeFormat="HH:mm"
                value={formState.menuItem_ASTime}
                onChange={handleASTimeChange}
                inputProps={{
                  placeholder: "Select start time (e.g., 09:00)",
                  className: `form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`,
                  style: {
                    borderRadius: "10px",
                    border: isDarkMode ? '1px solid #404040' : '1px solid #D9D9D9',
                    background: isDarkMode ? '#2d3436' : '#F9F9F9',
                    color: isDarkMode ? '#ffffff' : '#000000',
                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  }
                }}
              />
            </div>
            <div className="col-12">
              <label
                className="form-label fw-medium"
                style={{
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Available End Time
              </label>
              <DateTime
                dateFormat={false}
                timeFormat="HH:mm"
                value={formState.menuItem_AETime}
                onChange={handleAETimeChange}
                inputProps={{
                  placeholder: "Select end time (e.g., 17:00)",
                  className: `form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`,
                  style: {
                    borderRadius: "10px",
                    border: isDarkMode ? '1px solid #404040' : '1px solid #D9D9D9',
                    background: isDarkMode ? '#2d3436' : '#F9F9F9',
                    color: isDarkMode ? '#ffffff' : '#000000',
                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  }
                }}
              />
            </div>
            <div className="col-12">
              <FormInput
                label="Rating"
                value={formState.menuItem_Rating}
                onchange={handleInputChange("menuItem_Rating")}
                type="number"
                placeHolder="Rating (0-5)"
                name="menuItem_Rating"
                min="0"
                max="5"
                step="0.1"
              />
            </div>
            <div className="col-12">
              <FormInput
                label="Barcode"
                value={formState.menuItem_BarCode}
                onchange={handleInputChange("menuItem_BarCode")}
                type="text"
                placeHolder="Barcode"
                name="menuItem_BarCode"
              />
            </div> */}
          </div>
        </PanelBody>
      </Panel>
    </div>
  );

  const renderShimmer = () => (
    <div className="bg-white p-4 rounded-3 shadow-sm">
      <div className="shimmer">
        <div className="d-flex align-items-center mb-4">
          <div className="shimmer-line w-25 me-3" />
          <div className="shimmer-button" />
        </div>
        <div className="row mb-4 align-items-center">
          <div className="col-md-3 text-center">
            <div className="shimmer-image" />
          </div>
          <div className="col-md-9">
            <div className="row row-cols-2 g-3">
              <div className="col">
                <div className="shimmer-line w-75" />
              </div>
              <div className="col">
                <div className="shimmer-line w-50" />
              </div>
              <div className="col">
                <div className="shimmer-line w-60" />
              </div>
              <div className="col">
                <div className="shimmer-line w-40" />
              </div>
              <div className="col">
                <div className="shimmer-line w-55" />
              </div>
            </div>
          </div>
        </div>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="shimmer-line w-90" />
            <div className="shimmer-line w-80" />
            <div className="shimmer-block h-120" />
          </div>
          <div className="col-md-6">
            <div className="shimmer-line w-85" />
            <div className="shimmer-line w-70" />
            <div className="shimmer-block h-120" />
          </div>
        </div>
        <div className="shimmer-block h-140 mt-4" />
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3">
      {loading && !initialLoading && <Preloader />}
      {renderBreadcrumb()}
      {itemId && (
        <>
          <ItemTabBar 
            itemId={itemId} 
            hasUnsavedChanges={hasUnsavedChanges}
            onTabChange={handleTabChange}
          />
          <div className="d-flex align-items-center justify-content-end gap-2 mb-3 px-3">
            <button
              onClick={(e) => handleUpdate(e, false)}
              className="btn btn-rounded px-4 rounded-pill"
              disabled={loading || isParentCompanyProduct}
              style={{
                backgroundColor: themeColor,
                background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                border: 'none',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                boxShadow: `0 2px 8px ${themeColor}40`
              }}
              onMouseEnter={(e) => {
                if (!loading && !isParentCompanyProduct) {
                  e.target.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && !isParentCompanyProduct) {
                  e.target.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
                }
              }}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
            <button
              onClick={(e) => handleUpdate(e, true)}
              className="btn btn-rounded px-4 rounded-pill"
              disabled={loading || isParentCompanyProduct}
              style={{
                backgroundColor: themeColor,
                background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                border: 'none',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                boxShadow: `0 2px 8px ${themeColor}40`
              }}
              onMouseEnter={(e) => {
                if (!loading && !isParentCompanyProduct) {
                  e.target.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && !isParentCompanyProduct) {
                  e.target.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
                }
              }}
            >
              {loading ? 'Saving...' : 'Save and Exit'}
            </button>
          </div>
        </>
      )}

      {/* Warning banner for branch users viewing parent company products */}
      {isBranchMode && isParentCompanyProduct && (
        <div className="alert alert-warning d-flex align-items-center mb-3" role="alert">
          <i className="fa fa-exclamation-triangle me-2"></i>
          <div>
            <strong>Read-Only Mode:</strong> This product belongs to the parent company. 
            You are being redirected to the branch edit page where you can manage branch-specific settings.
          </div>
        </div>
      )}

      {initialLoading ? (
        renderShimmer()
      ) : (
        <>
          {/* Basic Information Panel */}
          {renderBasicInfoPanel()}

          {/* Measurements and Pricing Panels - Show Measurements for all items, Pricing always when no variants (modifier on or off) */}
          <div className="row g-3">
            {/* Measurements Panel - Show for all non-combo items (selling and non-selling) */}
            {!isComboItem && (
              <div className={toggles.menuItem_HasVariant ? "col-12" : "col-lg-6 col-md-6 col-sm-12"}>
                {renderMeasurementsPanel()}
              </div>
            )}
            {/* Pricing panel - Show whenever variants are disabled (both modifier on and off) */}
            {!toggles.menuItem_HasVariant && (
              <div className={isComboItem ? "col-12" : "col-lg-6 col-md-6 col-sm-12"}>
                {renderPricingPanel()}
              </div>
            )}
          </div>

          {/* Variants Panel - Only show when variants are enabled, selling, and not a combo item */}
          {toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant && !isComboItem && renderVariantsPanel()}

          {/* Reporting Category (Non-selling items only) */}
          {!isComboItem && !toggles.menuItem_IsSellingProduct && (
            <div className="row g-3 mb-3">
              <div className="col-12">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: "white",
                      border: "none",
                      borderRadius: "10px 10px 0 0",
                      padding: "12px 20px",
                      fontWeight: "600",
                      fontSize: "16px",
                    }}
                  >
                    <i className="fas fa-chart-bar me-2"></i>
                    Reporting Category *
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: "16px 20px",
                      backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                      borderRadius: "0 0 10px 10px",
                      border: `1px solid ${themeColor}20`,
                    }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{
                        padding: "12px 16px",
                        background: isDarkMode ? "#3d4447" : "#f8f9fa",
                        borderRadius: "8px",
                        border: isDarkMode
                          ? "1px solid rgba(255, 255, 255, 0.1)"
                          : "1px solid #e9ecef",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span
                          style={{
                            fontSize: "14px",
                            color: isDarkMode ? "#ffffff" : "#6c757d",
                            fontWeight: "500",
                          }}
                        >
                          Reporting category for this item is:{" "}
                          <strong
                            style={{
                              color: isDarkMode ? "#ffffff" : "#495057",
                              fontWeight: "600",
                            }}
                          >
                            {reportingCategory?.rootCat_Name ||
                              reportingCategory?.rC_Name ||
                              ((formState.reportCat_ID || reportingCategory?.rootCat_ID || reportingCategory?.rC_ID)
                                ? "Loading..."
                                : "Not selected")}
                          </strong>
                        </span>
                      </div>
                      <button
                        onClick={() =>
                          setModals((prev) => ({
                            ...prev,
                            showReportingCategoryModal: true,
                          }))
                        }
                        style={{
                          background: "transparent",
                          border: "none",
                          borderRadius: "6px",
                          padding: "6px 8px",
                          color: themeColor,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "32px",
                          height: "32px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = `${themeColor}20`;
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                        title="Edit reporting category"
                        type="button"
                      >
                        <i className="fa fa-edit" style={{ fontSize: "14px" }}></i>
                      </button>
                    </div>
                  </PanelBody>
                </Panel>
              </div>
            </div>
          )}

          {/* Categories and Menus Panel - Only show Categories for non-combo items */}
          {!isComboItem && toggles.menuItem_IsSellingProduct && (
            <div className="row g-3 mb-3">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-tags me-2"></i>
                    Categories & Classification
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`,
                      height: '100%'
                    }}
                  >
                    <CategorySelector
                      selectedCategories={selectors.selectedParentCategory}
                      setSelectedCategories={(updater) =>
                        setSelectors((prev) => {
                          const currentCats = prev.selectedParentCategory;
                          const newCats =
                            typeof updater === "function"
                              ? updater(currentCats)
                              : updater;
                          return { ...prev, selectedParentCategory: newCats };
                        })
                      }
                      showModal={modals.showParentCategoryModal}
                      setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showParentCategoryModal: true })) : setModals((prev) => ({ ...prev, showParentCategoryModal: false }))}
                      onModalSubmit={handleSelectorSubmit("selectedParentCategory")}
                      setLoading={setLoading}
                      excludeAddOnCategories={true}
                    />

                    {/* Reporting Category Display - Always show when categories are selected */}
                    {selectors.selectedParentCategory.length > 0 && (
                      <div className="mt-4">
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{
                            padding: "12px 16px",
                            background: isDarkMode ? "#3d4447" : "#f8f9fa",
                            borderRadius: "8px",
                            border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span style={{
                              fontSize: "14px",
                              color: isDarkMode ? "#ffffff" : "#6c757d",
                              fontWeight: "500"
                            }}>
                              Reporting category for this item is:{" "}
                              <strong style={{
                                color: isDarkMode ? "#ffffff" : "#495057",
                                fontWeight: "600"
                              }}>
                                {reportingCategory?.rootCat_Name ||
                                  reportingCategory?.rC_Name ||
                                  ((formState.reportCat_ID || reportingCategory?.rootCat_ID || reportingCategory?.rC_ID)
                                    ? "Loading..."
                                    : "Not selected")}
                              </strong>
                            </span>
                          </div>
                          <button
                            onClick={() => setModals((prev) => ({ ...prev, showReportingCategoryModal: true }))}
                            style={{
                              background: "transparent",
                              border: "none",
                              borderRadius: "6px",
                              padding: "6px 8px",
                              color: themeColor,
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              height: "32px",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = `${themeColor}20`;
                              e.currentTarget.style.transform = "scale(1.05)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                            title="Edit reporting category"
                          >
                            <i className="fa fa-edit" style={{ fontSize: "14px" }}></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </PanelBody>
                </Panel>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-th-list me-2"></i>
                    Menus
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`,
                      height: '100%'
                    }}
                  >
                    <MenuGroupsSelector
                      selectedGroups={selectors.selectedMenuGroups}
                      setSelectedGroups={(groups) =>
                        setSelectors((prev) => ({
                          ...prev,
                          selectedMenuGroups: Array.isArray(groups) ? groups : [],
                        }))
                      }
                      showModal={modals.showMenuGroupModal}
                      setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showMenuGroupModal: true })) : setModals((prev) => ({ ...prev, showMenuGroupModal: false }))}
                      onModalSubmit={handleSelectorSubmit("selectedMenuGroups")}
                      setLoading={setLoading}
                    />
                  </PanelBody>
                </Panel>
              </div>
            </div>
          )}

          {/* Combo Products Panel */}
          {isComboItem && renderComboProductsPanel()}

          {/* Menus & Allergens Panel - Only for combo items */}
          {isComboItem && toggles.menuItem_IsSellingProduct && (
            <div className="row g-3 mb-3">
              <div className="col-6">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-th-list me-2"></i>
                    Menus
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`,
                      height: '100%'
                    }}
                  >
                    <MenuGroupsSelector
                      selectedGroups={selectors.selectedMenuGroups}
                      setSelectedGroups={(groups) =>
                        setSelectors((prev) => ({
                          ...prev,
                          selectedMenuGroups: Array.isArray(groups) ? groups : [],
                        }))
                      }
                      showModal={modals.showMenuGroupModal}
                      setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showMenuGroupModal: true })) : setModals((prev) => ({ ...prev, showMenuGroupModal: false }))}
                      onModalSubmit={handleSelectorSubmit("selectedMenuGroups")}
                      setLoading={setLoading}
                    />
                  </PanelBody>
                </Panel>
              </div>
              <div className="col-6">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Allergens
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`,
                      height: '100%'
                    }}
                  >
                    <AllergenSelector
                      selectedAllergens={selectors.selectedAllergens}
                      setSelectedAllergens={(allergens) =>
                        setSelectors((prev) => ({
                          ...prev,
                          selectedAllergens: allergens,
                        }))
                      }
                      showModal={modals.showAllergenModal}
                      setShowModal={(val) => val ? setModals((prev) => ({ ...prev, showAllergenModal: true })) : setModals((prev) => ({ ...prev, showAllergenModal: false }))}
                      onModalSubmit={handleSelectorSubmit("selectedAllergens")}
                      allergens={allAllergens}
                      setLoading={setLoading}
                    />
                  </PanelBody>
                </Panel>
              </div>
            </div>
          )}

          {/* Add-on Groups & Allergens Panel */}
          {renderModifiersAllergensPanel()}

          {/* SEO, Product Settings, and Additional Options Panels */}
          <div className="row g-3 mb-3">
            {toggles.menuItem_IsSellingProduct && (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <Panel className="h-100">
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-search me-2"></i>
                    Search Ranking Improvement
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`,
                      height: '100%'
                    }}
                  >
                    {renderSEO()}
                  </PanelBody>
                </Panel>
              </div>
            )}
           
            <div className={toggles.menuItem_IsSellingProduct ? "col-lg-6 col-md-6 col-sm-12" : "col-12"}>
              {renderAdditionalOptions()}
            </div>
          </div>

          {/* <div className="row g-3 mt-2">
            {renderAdditionalFlags()}
            {renderOtherSection()}
          </div> */}

          {/* Branch Management (Assignment + Overrides) - Only show for parent branches */}
          {isParentBranch && (
            <div className="row g-3 mb-3">
              <div className="col-12">
                <Panel>
                  <PanelHeader
                    style={{
                      backgroundColor: themeColor,
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px 10px 0 0',
                      padding: '12px 20px',
                      fontWeight: '600',
                      fontSize: '16px'
                    }}
                  >
                    <i className="fas fa-code-branch me-2"></i>
                    Branch Management
                  </PanelHeader>
                  <PanelBody
                    style={{
                      padding: '16px 20px',
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      borderRadius: '0 0 10px 10px',
                      border: `1px solid ${themeColor}20`
                    }}
                  >
                    {/* Assignment section */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <h6 style={{ marginBottom: '5px', fontWeight: '600' }}>
                          Assign to Branches
                        </h6>
                        <p style={{ margin: 0, color: isDarkMode ? '#b2bec3' : '#6c757d', fontSize: '14px' }}>
                          Select which branches should have access to this product
                        </p>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setModals((prev) => ({ ...prev, showBranchAssignmentModal: true }))}
                        style={{
                          backgroundColor: themeColor,
                          border: 'none',
                          borderRadius: '8px',
                          padding: '8px 16px',
                          fontSize: '14px',
                          fontWeight: '500'
                        }}
                      >
                        <i className="fas fa-edit me-2"></i>
                        Manage Branches
                      </button>
                    </div>
                    {selectedBranches.length > 0 ? (
                      <div style={{
                        padding: '15px',
                        backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                        borderRadius: '8px',
                        border: `1px solid ${themeColor}30`
                      }}>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fas fa-check-circle me-2" style={{ color: themeColor }}></i>
                          <span style={{ fontWeight: '500' }}>
                            Assigned to {selectedBranches.length} branch{selectedBranches.length !== 1 ? 'es' : ''}
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {selectedBranches.map((branch) => {
                            const branchId = typeof branch === 'number' ? branch : (branch.CompID || branch.compID || branch.branchCompID);
                            const branchName = typeof branch === 'object'
                              ? (branch.CompName || branch.compName || branch.Comp_Name || "Branch")
                              : "Branch";
                            return (
                              <span
                                key={branchId}
                                className="badge"
                                style={{
                                  backgroundColor: `${themeColor}20`,
                                  color: themeColor,
                                  padding: '6px 12px',
                                  fontSize: '13px',
                                  fontWeight: '500'
                                }}
                              >
                                {branchName}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <div style={{
                        padding: '15px',
                        backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                        borderRadius: '8px',
                        border: `1px dashed ${themeColor}50`,
                        textAlign: 'center',
                        color: isDarkMode ? '#b2bec3' : '#6c757d'
                      }}>
                        <i className="fas fa-info-circle me-2"></i>
                        No branches assigned yet. Click \"Manage Branches\" to assign this product to child branches.
                      </div>
                    )}

                    {/* Divider */}
                    <div
                      style={{
                        height: 1,
                        backgroundColor: isDarkMode ? '#404040' : '#e9ecef',
                        margin: '22px 0'
                      }}
                    />

                    {/* Overrides section */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <h6 style={{ marginBottom: '5px', fontWeight: '600' }}>
                          Branch Overrides
                        </h6>
                        <p style={{ margin: 0, color: isDarkMode ? '#b2bec3' : '#6c757d', fontSize: '14px' }}>
                          Review and manage overrides (publish, prices) per branch
                        </p>
                      </div>
                    </div>

                    {branchAssignments && branchAssignments.length > 0 ? (
                      // If this product has variants, show per-variant rows (no main-product entry)
                      !!toggles.menuItem_HasVariant ? (
                        <div className="table-responsive">
                          {loadingBranchVariantOverrides && (
                            <div className="text-muted mb-2" style={{ fontSize: 12 }}>
                              Loading variant overrides...
                            </div>
                          )}
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Branch</th>
                                <th>Variant Title</th>
                                <th>Variant</th>
                                <th className="text-center">Publish</th>
                                <th className="text-center">Price Override</th>
                                <th className="text-center">Sale</th>
                                <th className="text-center">Delivery</th>
                                <th className="text-center">Takeaway</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(branchVariantOverrideRows || []).length === 0 ? (
                                <tr>
                                  <td colSpan={10} className="text-center text-muted">
                                    No variant override rows found.
                                  </td>
                                </tr>
                              ) : (
                                branchVariantOverrideRows.map((r) => {
                                  const effectiveSale =
                                    r.isPriceOverrideActive && r.branchPriceOverride !== null && r.branchPriceOverride !== undefined
                                      ? r.branchPriceOverride
                                      : parseFloat(r.menuItem_SalePrice || 0);
                                  const effectiveDelivery =
                                    r.isPriceOverrideActive && r.branchDeliveryPriceOverride !== null && r.branchDeliveryPriceOverride !== undefined
                                      ? r.branchDeliveryPriceOverride
                                      : parseFloat(r.menuItem_DeliveryPrice || 0);
                                  const effectiveTakeaway =
                                    r.isPriceOverrideActive && r.branchTakeAwayPriceOverride !== null && r.branchTakeAwayPriceOverride !== undefined
                                      ? r.branchTakeAwayPriceOverride
                                      : parseFloat(r.menuItem_TakeAwayPrice || 0);

                                  const publishLabel =
                                    r.branchPublish === null || r.branchPublish === undefined
                                      ? "Inherit"
                                      : r.branchPublish ? "Published" : "Unpublished";

                                  // Find branch assignment object for actions (opens per-branch variant editor)
                                  const branchAssignment = (branchAssignments || []).find(
                                    (a) => (a.branchCompID ?? a.BranchCompID) === r.branchCompId && a.isAssigned
                                  );

                                  return (
                                    <tr key={`${r.branchCompId}-${r.variantId}`}>
                                      <td className="align-middle">
                                        <div style={{ fontWeight: 600 }}>{r.branchName}</div>
                                      </td>
                                      <td className="align-middle">{r.variantTitle || "-"}</td>
                                      <td className="align-middle">{r.variantName || "-"}</td>
                                      <td className="align-middle text-center">{publishLabel}</td>
                                      <td className="align-middle text-center">
                                        {r.isPriceOverrideActive ? "Enabled" : "Disabled"}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveSale || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveDelivery || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveTakeaway || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        <div className="d-flex justify-content-center gap-2">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            style={{ borderColor: themeColor, color: themeColor }}
                                            onClick={() => branchAssignment && openBranchOverrideModal(branchAssignment)}
                                            disabled={!branchAssignment}
                                          >
                                            Edit
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => branchAssignment && resetBranchOverrideFromParent(branchAssignment)}
                                            disabled={!branchAssignment}
                                          >
                                            Reset
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Branch</th>
                                <th className="text-center">Publish</th>
                                <th className="text-center">Price Override</th>
                                <th className="text-center">Sale</th>
                                <th className="text-center">Delivery</th>
                                <th className="text-center">Takeaway</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {branchAssignments
                                .filter((a) => a.isAssigned)
                                .map((a) => {
                                  const effectiveSale =
                                    a.isPriceOverrideActive && a.branchPriceOverride !== null && a.branchPriceOverride !== undefined
                                      ? a.branchPriceOverride
                                      : parseFloat(formState.menuItem_SalePrice || 0);
                                  const effectiveDelivery =
                                    a.isPriceOverrideActive && a.branchDeliveryPriceOverride !== null && a.branchDeliveryPriceOverride !== undefined
                                      ? a.branchDeliveryPriceOverride
                                      : parseFloat(formState.menuItem_DeliveryPrice || 0);
                                  const effectiveTakeaway =
                                    a.isPriceOverrideActive && a.branchTakeAwayPriceOverride !== null && a.branchTakeAwayPriceOverride !== undefined
                                      ? a.branchTakeAwayPriceOverride
                                      : parseFloat(formState.menuItem_TakeAwayPrice || 0);

                                  const publishLabel =
                                    a.branchPublish === null || a.branchPublish === undefined
                                      ? "Inherit"
                                      : a.branchPublish ? "Published" : "Unpublished";

                                  return (
                                    <tr key={a.id}>
                                      <td className="align-middle">
                                        <div style={{ fontWeight: 600 }}>
                                          {a.branchName ??
                                            a.BranchName ??
                                            a.compName ??
                                            a.CompName ??
                                            a.branchCompany?.compName ??
                                            a.branchCompany?.CompName ??
                                            "Branch"}
                                        </div>
                                      </td>
                                      <td className="align-middle text-center">{publishLabel}</td>
                                      <td className="align-middle text-center">
                                        {a.isPriceOverrideActive ? "Enabled" : "Disabled"}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveSale || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveDelivery || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        {getCurrencySymbol(compCurrency)} {Number(effectiveTakeaway || 0).toFixed(2)}
                                      </td>
                                      <td className="align-middle text-center">
                                        <div className="d-flex justify-content-center gap-2">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            style={{ borderColor: themeColor, color: themeColor }}
                                            onClick={() => openBranchOverrideModal(a)}
                                          >
                                            Edit
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => resetBranchOverrideFromParent(a)}
                                          >
                                            Reset
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )
                    ) : (
                      <div style={{
                        padding: '15px',
                        backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                        borderRadius: '8px',
                        border: `1px dashed ${themeColor}50`,
                        textAlign: 'center',
                        color: isDarkMode ? '#b2bec3' : '#6c757d'
                      }}>
                        <i className="fas fa-info-circle me-2"></i>
                        No assigned branches found for this product.
                      </div>
                    )}
                  </PanelBody>
                </Panel>
              </div>
            </div>
          )}

          {/* Reporting Category Modal */}
          <ReportingCategoryModel
            isModalOpen={modals.showReportingCategoryModal}
            setIsModalOpen={(val) =>
              setModals((prev) => ({
                ...prev,
                showReportingCategoryModal: val,
              }))
            }
            onCategorySubmit={handleReportingCategorySubmit}
            compID={CompID}
            selectedCategory={reportingCategory}
            categories={allCategories}
            showButton={true}
          />

          {/* Branch Assignment Selector Modal */}
          {isParentBranch && (
            <BranchAssignmentSelector
              isOpen={modals.showBranchAssignmentModal}
              onClose={() => setModals((prev) => ({ ...prev, showBranchAssignmentModal: false }))}
              selectedBranches={selectedBranches}
              setSelectedBranches={setSelectedBranches}
              productId={itemId}
              parentCompID={CompID}
              onSubmitSelection={saveBranchAssignmentsFromSection}
            />
          )}

          {/* Parent: Branch Override Modal */}
          {isParentBranch && (
            <CustomModal
              title="Branch Overrides"
              subtitle="Update or reset overrides for this branch."
              isOpen={branchOverrideModalOpen}
              onClose={closeBranchOverrideModal}
              isCentered={true}
              showButton={true}
              onSubmit={saveBranchOverrideFromParent}
              submitButtonText="Save"
              submitButtonDisabled={loading}
              modalSize="modal-lg"
            >
              <div style={{ padding: 20 }}>
                <div
                  className="mb-4"
                  style={{
                    padding: 14,
                    borderRadius: 14,
                    backgroundColor: isDarkMode ? "#1e2124" : "#f8f9fa",
                    border: `1px solid ${themeColor}20`,
                  }}
                >
                  <div className="fw-bold" style={{ fontSize: 14 }}>
                    Branch
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600, marginTop: 4 }}>
                    {editingBranchAssignment?.branchName || `Branch ${editingBranchAssignment?.branchCompID || ""}`}
                  </div>
                  <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
                    Product: {formState.menuItem_Name || "-"}
                  </div>
                </div>

                {isVariantBranchOverrideMode ? (
                  <div>
                    <div className="text-muted mb-3" style={{ fontSize: 12 }}>
                      This item has variants. Branch overrides are managed per variant (main product has no override entry).
                    </div>

                    {variantBranchOverrideItems.length === 0 ? (
                      <div
                        style={{
                          padding: '15px',
                          backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                          borderRadius: '8px',
                          border: `1px dashed ${themeColor}50`,
                          textAlign: 'center',
                          color: isDarkMode ? '#b2bec3' : '#6c757d'
                        }}
                      >
                        <i className="fas fa-info-circle me-2"></i>
                        No variants found for this product.
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Variant</th>
                              <th className="text-center">Publish</th>
                              <th className="text-center">Price Override</th>
                              <th className="text-center">Sale</th>
                              <th className="text-center">Delivery</th>
                              <th className="text-center">Takeaway</th>
                            </tr>
                          </thead>
                          <tbody>
                            {variantBranchOverrideItems.map((v) => {
                              const vid = v?.menuItem_ID ?? v?.MenuItem_ID;
                              const assignmentId = v?.branchAssignmentID ?? v?.BranchAssignmentID;
                              const form = variantBranchOverrideForms[vid] || {};
                              const disabled = !assignmentId;

                              const updateForm = (patch) =>
                                setVariantBranchOverrideForms((prev) => ({
                                  ...prev,
                                  [vid]: { ...(prev[vid] || {}), ...patch },
                                }));

                              return (
                                <tr key={vid}>
                                  <td className="align-middle">
                                    <div style={{ fontWeight: 600 }}>
                                      {v?.menuItem_Name || v?.MenuItem_Name || "-"}
                                    </div>
                                    {(v?.menuItem_DefaultVariantTitle || v?.MenuItem_DefaultVariantTitle) && (
                                      <div className="text-muted" style={{ fontSize: 12 }}>
                                        Title: {v?.menuItem_DefaultVariantTitle || v?.MenuItem_DefaultVariantTitle}
                                      </div>
                                    )}
                                    <div className="text-muted" style={{ fontSize: 12 }}>
                                      ID: {vid} {disabled ? "| not assigned" : ""}
                                    </div>
                                  </td>

                                  <td className="align-middle text-center">
                                    <select
                                      className="form-select"
                                      value={form.branchPublishMode || "inherit"}
                                      disabled={disabled}
                                      onChange={(e) => updateForm({ branchPublishMode: e.target.value })}
                                      style={{
                                        borderRadius: 10,
                                        backgroundColor: isDarkMode ? "#1e2124" : "#ffffff",
                                        border: `1px solid ${themeColor}30`,
                                        color: isDarkMode ? "#ffffff" : "#000000",
                                      }}
                                    >
                                      <option value="inherit">Inherit</option>
                                      <option value="publish">Publish</option>
                                      <option value="unpublish">Unpublish</option>
                                    </select>
                                  </td>

                                  <td className="align-middle text-center">
                                    <ToggleSwitch
                                      isChecked={!!form.isPriceOverrideActive}
                                      onToggle={(checked) => updateForm({ isPriceOverrideActive: checked })}
                                      label="Enable"
                                      name={`variantBranchPriceOverrideActive_${vid}`}
                                      size="small"
                                      disabled={disabled}
                                    />
                                  </td>

                                  <td className="align-middle text-center">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={form.branchPriceOverride ?? ""}
                                      disabled={disabled || !form.isPriceOverrideActive}
                                      onChange={(e) => updateForm({ branchPriceOverride: e.target.value })}
                                      placeholder="inherit"
                                      style={{
                                        borderRadius: 10,
                                        backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                                        border: `1px solid ${themeColor}30`,
                                        color: isDarkMode ? "#ffffff" : "#000000",
                                      }}
                                    />
                                  </td>

                                  <td className="align-middle text-center">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={form.branchDeliveryPriceOverride ?? ""}
                                      disabled={disabled || !form.isPriceOverrideActive}
                                      onChange={(e) => updateForm({ branchDeliveryPriceOverride: e.target.value })}
                                      placeholder="inherit"
                                      style={{
                                        borderRadius: 10,
                                        backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                                        border: `1px solid ${themeColor}30`,
                                        color: isDarkMode ? "#ffffff" : "#000000",
                                      }}
                                    />
                                  </td>

                                  <td className="align-middle text-center">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={form.branchTakeAwayPriceOverride ?? ""}
                                      disabled={disabled || !form.isPriceOverrideActive}
                                      onChange={(e) => updateForm({ branchTakeAwayPriceOverride: e.target.value })}
                                      placeholder="inherit"
                                      style={{
                                        borderRadius: 10,
                                        backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                                        border: `1px solid ${themeColor}30`,
                                        color: isDarkMode ? "#ffffff" : "#000000",
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="row g-3 mb-4">
                      <div className="col-md-12">
                        <label className="form-label fw-bold">Publish override</label>
                        <select
                          className="form-select"
                          value={branchOverrideForm.branchPublishMode}
                          onChange={(e) =>
                            setBranchOverrideForm((p) => ({ ...p, branchPublishMode: e.target.value }))
                          }
                          style={{
                            borderRadius: 12,
                            backgroundColor: isDarkMode ? "#1e2124" : "#ffffff",
                            border: `1px solid ${themeColor}30`,
                            color: isDarkMode ? "#ffffff" : "#000000",
                          }}
                        >
                          <option value="inherit">Inherit (use master)</option>
                          <option value="publish">Publish</option>
                          <option value="unpublish">Unpublish</option>
                        </select>
                      </div>

                    </div>

                <div
                  className="mb-3"
                  style={{
                    padding: 14,
                    borderRadius: 14,
                    backgroundColor: isDarkMode ? "#1e2124" : "#ffffff",
                    border: `1px solid ${themeColor}20`,
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <div className="fw-bold" style={{ fontSize: 14 }}>
                        Pricing overrides
                      </div>
                      <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>
                        Overrides apply only when enabled and value is provided.
                      </div>
                    </div>

                    <ToggleSwitch
                      isChecked={!!branchOverrideForm.isPriceOverrideActive}
                      onToggle={(checked) =>
                        setBranchOverrideForm((p) => ({ ...p, isPriceOverrideActive: checked }))
                      }
                      label="Enable"
                      name="parentBranchPriceOverrideActive"
                      size="small"
                    />
                  </div>

                  <div className="row g-3 mt-1">
                    <div className="col-md-4">
                      <label className="form-label fw-bold">Sale price override</label>
                      <input
                        type="number"
                        className="form-control"
                        value={branchOverrideForm.branchPriceOverride}
                        onChange={(e) =>
                          setBranchOverrideForm((p) => ({ ...p, branchPriceOverride: e.target.value }))
                        }
                        placeholder="Leave empty to inherit"
                        style={{
                          borderRadius: 12,
                          backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                          border: `1px solid ${themeColor}30`,
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">Delivery price override</label>
                      <input
                        type="number"
                        className="form-control"
                        value={branchOverrideForm.branchDeliveryPriceOverride}
                        onChange={(e) =>
                          setBranchOverrideForm((p) => ({ ...p, branchDeliveryPriceOverride: e.target.value }))
                        }
                        placeholder="Leave empty to inherit"
                        style={{
                          borderRadius: 12,
                          backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                          border: `1px solid ${themeColor}30`,
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold">Takeaway price override</label>
                      <input
                        type="number"
                        className="form-control"
                        value={branchOverrideForm.branchTakeAwayPriceOverride}
                        onChange={(e) =>
                          setBranchOverrideForm((p) => ({ ...p, branchTakeAwayPriceOverride: e.target.value }))
                        }
                        placeholder="Leave empty to inherit"
                        style={{
                          borderRadius: 12,
                          backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                          border: `1px solid ${themeColor}30`,
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      />
                    </div>
                  </div>
                </div>
                  </>
                )}
              </div>
            </CustomModal>
          )}
        </>
      )}
    </div>
  );
};

export default UpdateItem;
